<template>
    <div class="page-layout">
        <div class="page-layout blank">
            <div class="pb-10" style="min-height: 600px;">
                <div v-if="url_not_found" class="vendor-list py-3 mt-3">
                    <div class="text-center">
                        <h3 class="text-danger">
                            <span class="pl-2">
                                Scanned QR Code data is not found in the system. Please scan again.
                            </span>
                        </h3>
                    </div>
                    <div class="d-flex align-items-center justify-content-center mt-10 mb-4">
                        <button type="button" class="btn btn-new-primary" @click="goToListView" >Close</button>
                    </div>
                </div>
                <div v-else-if="facility_id_not_active" class="vendor-list py-3 mt-3">
                    <div class="text-center">
                        <h3 class="text-danger">
                            <span class="pl-2">
                                QR Code Associated with Facility Area and Location is Inactive.
                            </span>
                        </h3>
                        <div class="d-flex align-items-center justify-content-center mt-10 mb-4">
                            <button type="button" class="btn btn-new-primary" @click="goToListView" >Close</button>
                        </div>
                    </div>
                </div>
                <div v-else class="vendor-list py-3 mt-3">
                    <h1 v-if="!is_view_screen" class="text-new-blue fs-16 fw-600 text-center pt-3 pt-2">SECURITY CHECK</h1>
                    <h1 v-else class="text-new-blue fs-16 fw-600 text-center pt-3 pt-2">SECURITY CONCERN DETAILS</h1>
                    <div class="inner-content-border my-5 mx-4">
                        <div class="header-outer pl-5">
                            <span class="fw-500">Details of the Concern</span>
                        </div>
                        <div v-if="ajax_call_inprogress">
                            <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                        </div>
                        <div v-else class="">
                            <div class="row m-0" v-if="ticket_details.ticket_id && ticket_details.ticket_number && is_view_screen">
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="form-group contactGroup">
                                        <div class="w-100" style="position: relative;">
                                            <label class="inputLabel fs-14 fw-600 text-black">Ticket Number : <span class="text-secondary pointer" @click="goToTicketDetails">{{'#' + ticket_details.ticket_number}}</span></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-0">
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="form-group contactGroup">
                                        <div class="w-100" style="position: relative;">
                                            <label class="inputLabel fs-14 fw-600 text-black">Tag Location</label>
                                            <input v-if="!is_view_screen" class="inputFieldNew inputFieldNew-padding" readonly name="tag_location" style="padding-right: 60px !important;" v-model="tag_location" type="text" autocomplete="off" placeholder="Autofilled from the scanner" />
                                            <input v-else class="inputFieldNew inputFieldNew-padding" readonly name="tag_location" style="padding-right: 30px !important;" v-model="tag_location" type="text" autocomplete="off" placeholder="Autofilled from the scanner" />
                                            <span class="inputBorder"></span>
                                            <i v-if="!is_view_screen" class="icon icon-map-marker text-blue" style="position: absolute;right: 35px;top: 45px;"></i>
                                            <i v-else class="icon icon-map-marker text-blue" style="position: absolute;right: 5px;top: 45px;"></i>
                                            <i v-if="!is_view_screen" class="icon icon-check-circle fs-24 text-success ml-2" style="position: absolute;right: 10px;top: 45px;"></i>
                                        </div>
                                    </div>
                                    <el-checkbox v-model="assign_a_ticket" v-if="!is_view_screen" :disabled="is_view_screen" class="mt-2 ml-2">Assign a ticket</el-checkbox>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="form-group contactGroup">
                                        <div class="w-100" style="position: relative;">
                                            <label class="inputLabel fs-14 fw-600 text-black">Facility Name</label>
                                            <input class="inputFieldNew inputFieldNew-padding" readonly name="product" v-model="facility_name" type="text" autocomplete="off" placeholder="Autofilled from the scanner" />
                                            <span class="inputBorder"></span>
                                            <i v-if="!is_view_screen" class="icon icon-check-circle fs-24 text-success ml-2" style="position: absolute;right: 10px;top: 45px;"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="form-group contactGroup">
                                        <span class="whiteSpace fs-14 fw-600 text-black">Date and Time <span v-if="!is_view_screen" class="text-danger">*</span></span>
                                        <div class="">
                                            <div class="d-flex report-date-time-picker facility-management-datepicker align-items-center mt-3" :class="{'facility-management-datepicker-view-screen':is_view_screen}">
                                                <date-picker
                                                    v-model="date_and_time.date"
                                                    name="date"
                                                    class="ticketdate w-50 ticketDateHeight"
                                                    format="MM/DD/YYYY"
                                                    type="date"
                                                    :disabled="true"
                                                    lang="en"
                                                    value-type="format"
                                                    :clearable="false"
                                                    :editable="true"
                                                    confirm
                                                    confirm-text="APPLY"
                                                    v-validate="'required'"
                                                ></date-picker>
                                                <date-picker
                                                    v-model="date_and_time.time"
                                                    format="hh:mm A"
                                                    name="time"
                                                    class="tickettime w-50"
                                                    type="time"
                                                    placeholder="Select Time"
                                                    :disabled="true"
                                                    value-type="format"
                                                    lang="en"
                                                    :clearable="false"
                                                    :editable="true"
                                                    :minute-step="1"
                                                    confirm
                                                    confirm-text="APPLY"
                                                    v-validate="'required'"
                                                >
                                                </date-picker>
                                                <div v-if="!is_view_screen" class="success-check">
                                                    <i class="icon icon-check-circle fs-24 text-success ml-2"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-if="is_date && is_time">Date and Time is required.</span>
                                        <span class="invalid-feedback-form text-danger" v-else-if="is_date">Date is required.</span>
                                        <span class="invalid-feedback-form text-danger" v-else-if="is_time">Time is required.</span>
                                    </div>
                                </div>
                                <!-- <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="form-group contactGroup">
                                        <span class="whiteSpace fs-14 fw-600 text-black">Department <span v-if="!is_view_screen" class="text-danger">*</span></span>
                                        <div class="">
                                            <multiselect v-if="!is_view_screen"
                                                class="diginew-multiselect diginew-multiselect-dropdown mt-3"
                                                v-model="department"
                                                :loading="departments_loading"
                                                :options="department_options"
                                                :searchable="true"
                                                :disabled="is_view_screen"
                                                label="name"
                                                name="department"
                                                @open="openDepartmentList"
                                                @search-change="searchDepartmentList"
                                                :close-on-select="true"
                                                v-validate="'required'"
                                                :show-labels="false"
                                                placeholder="Search & Select Department"
                                                internal-search="true"
                                            >
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfDepartmentList" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                            <input v-else class="inputFieldNew inputFieldNew-padding" readonly name="department_name" v-model="department.name" type="text" autocomplete="off" />
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-show="errors.has('department')">{{errors.first('department')}}</span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="form-group contactGroup">
                                        <span class="whiteSpace fs-14 fw-600 text-black">Priority <span v-if="!is_view_screen" class="text-danger">*</span></span>
                                        <div class="">
                                            <multiselect v-if="!is_view_screen"
                                                class="diginew-multiselect diginew-multiselect-dropdown mt-3"
                                                v-model="priority"
                                                :options="priority_options"
                                                :searchable="false"
                                                :close-on-select="true"
                                                :disabled="is_view_screen"
                                                v-validate="'required'"
                                                name="priority"
                                                :show-labels="false"
                                                placeholder="Select Priority"
                                                internal-search="true"
                                            >
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                            <input v-else class="inputFieldNew inputFieldNew-padding" readonly name="priority" v-model="priority" type="text" autocomplete="off" />
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-show="errors.has('priority')">{{errors.first('priority')}}</span>
                                    </div>
                                </div> -->
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="form-group contactGroup">
                                        <div class="w-100" style="position: relative;">
                                            <label class="inputLabel fs-14 fw-600 text-black mb-0">Assigned By <span v-if="!is_view_screen" class="text-danger">*</span></label>
                                            <input class="inputFieldNew inputFieldNew-padding" readonly v-validate="'required'" name="assigned_by" v-model="assigned_by_name" type="text" autocomplete="off" placeholder="Autofilled from the scanner" />
                                            <span class="inputBorder"></span>
                                            <i v-if="!is_view_screen" class="icon icon-check-circle fs-24 text-success ml-2" style="position: absolute;right: 10px;top: 40px;"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row align-items-end m-0">
                                <div class="col-lg-4 col-md-6 col-sm-12" v-if="assign_a_ticket">
                                    <div class="form-group contactGroup" style="margin-top: 0px;z-index:1 !important;">
                                        <div class="vendor_type">
                                            <label class="text-black mr-2" style="font-size: 14px;margin-bottom: 0px;">Assigned to
                                                <span v-if="!is_view_screen" class="text-danger ml-1">*</span>
                                            </label>
                                            <el-radio-group :disabled="is_view_screen" class="d-flex align-items-center mt-2 mob-issue-fix" v-model="assignment_details.to">
                                                <el-radio @input="assignedToChange()" :disabled="is_view_screen" label="person">
                                                    Person
                                                </el-radio>
                                                <el-tooltip class="item pull-right" :disabled="is_view_screen" effect="dark" content="Unassigned Coming Soon" placement="top">
                                                    <el-radio disabled @input="assignedToChange()" label="unassigned">
                                                        Unassigned
                                                    </el-radio>
                                                </el-tooltip>
                                                <el-tooltip :disabled="is_view_screen" class="item pull-right" effect="dark" content="Assigning Tickets To Teams Coming Soon" placement="top">
                                                    <el-radio disabled @input="assignedToChange()" label="team">
                                                        Team
                                                    </el-radio>
                                                </el-tooltip>
                                            </el-radio-group>
                                        </div>
                                        <multiselect  v-if="!is_view_screen" label="name"
                                            v-validate="'required'"
                                            class="diginew-multiselect custom-cred-fs mt-3"
                                            name="assign_to"
                                            v-model="assignment_details.assigned_to"
                                            :options="assign_options"
                                            :disabled="is_view_screen"
                                            :searchable="true"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Select Name"
                                            :loading="assign_loading" @search-change="getAllAssignTo"
                                        >
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfAssigned" />
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <input v-else class="inputFieldNew inputFieldNew-padding" readonly name="assigned_to" v-model="assignment_details.assigned_to.name" type="text" autocomplete="off" />
                                        <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('assign_to')">{{ errors.first("assign_to") }}</span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12" v-if="assign_a_ticket">
                                    <div class="form-group contactGroup" style="margin-top: 0px;z-index:1 !important;">
                                        <div class="vendor_type">
                                            <label class="text-black mr-2" style="font-size: 14px;margin-bottom: 0px;">Ticket Template
                                                <span v-if="!is_view_screen" class="text-danger ml-1">*</span>
                                            </label>
                                        </div>
                                        <multiselect :title="ticketType.name"
                                            v-model="ticketType"
                                            class="diginew-multiselect overflow-text custom-cred-fs mt-3"
                                            :loading="ticket_type_loading"
                                            :options="ticket_type_options"
                                            :searchable="true" :disabled="is_view_screen"
                                            :close-on-select="true"
                                            name="ticketType"
                                            :show-labels="false"
                                            @select="selectedTemplate"
                                            @open="getTicketTemplate"
                                            @close="checkTicketType"
                                            :allow-empty="false"
                                            @search-change="searchTemplate"
                                            :multiple="false"
                                            :options-limit="3000"
                                            :max-height="200"
                                            v-validate="'required'"
                                            :clear-on-select="false"
                                            label="name"
                                            :internal-search="true"
                                            :show-no-results="true"
                                            :hide-selected="false"
                                        >
                                            <template slot="placeholder">
                                                <span class="diginewhelp-multiselect">Select Ticket Template</span>
                                            </template>
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfTicketTemplate" />
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('ticketType')">{{ errors.first("ticketType") }}</span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-3" v-if="is_approvers_mandatory">
                                    <div class="form-group contactGroup pt-0">
                                        <span class="fs-13 fw-600 text-black">
                                            Approver <span class="text-danger"> *</span>
                                        </span>
                                        <div class="d-flex align-items-center mt-3">
                                            <multiselect
                                                v-model="approvers_data" id="ajax" :block-keys="['Tab', 'Enter']"
                                                class="diginew-multiselect overflow-text arrow-custom h-100px-ms filter-multiple custom-cred-fs"
                                                :options="approvers_options"
                                                data-vv-as="Approver" track-by="id"
                                                :searchable="true"
                                                :close-on-select="false"
                                                name="approversData"
                                                :show-labels="false"
                                                :multiple="true"
                                                :options-limit="3000"
                                                :max-height="200"
                                                :min-height="100"
                                                v-validate="is_approvers_mandatory ? 'required' : ''"
                                                :clear-on-select="true"
                                                label="name"
                                                :internal-search="true"
                                                :show-no-results="true"
                                                :allow-empty="true"
                                                :hide-selected="true"
                                                :blockKeys="['Delete']"
                                            >
                                                <template slot="tag" slot-scope="{ option }">
                                                    <span class="custom__tag1">
                                                    <span class="filterSelectedName1">{{ option.name }}</span>
                                                        <span class="custom__remove pointer">
                                                            <i class="icon icon-close fs-16 text-white" style="display:none"></i>
                                                        </span>
                                                        <span class="custom__remove pointer" @click="removeApprovers(option)">
                                                        <i class="icon icon-close fs-16 text-white"></i>
                                                        </span>
                                                    </span>
                                                </template>
                                                <template slot="afterList" v-if="watchApprovers">
                                                    <div class="d-flex align-items-center justify-content-center" style="height:40px !important">
                                                        <span class="diginewhelp-multiselect">All the options are selected</span>
                                                    </div>
                                                </template>
                                                <template slot="placeholder">
                                                    <span class="diginewhelp-multiselect">Select Approvers</span>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">No Options Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('approversData')">{{ errors.first("approversData") }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-0">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <div class="form-group contactGroup">
                                        <div class="w-100" style="position: relative;">
                                            <label class="inputLabel fs-14 fw-600 text-black">comments</label>
                                            <textarea class="inputFieldNew w-100" name="comments" :disabled="is_view_screen" maxlength="1000" v-model="comments" style="resize: none;" rows="4" placeholder="Add comments" />
                                            <span class="fs-14 text-right d-block">
                                                {{1000 - (comments).length}}/1000
                                            </span>
                                        </div>
                                        <span class="invalid-feedback-form text-danger mt-0" v-show="errors.has('notes')">{{errors.first('notes')}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="general-section pb-6 row m-0 mt-3 px-0 px-lg-4" v-if="template_details.length > 0 && assign_a_ticket">
                                <div class="col-lg-12 col-md-12 col-sm-12 mt-3 px-0">
                                    <div class="row justify-content-between boxHeader mt-4 py-2" v-if="ticket_details.template_type == 'default' || ticket_details.template_type == 'multi_part'">
                                        <div>Ticket Details</div>
                                    </div>
                                </div>

                                <div v-if="ticket_details.template_type == 'multi_part'" class="w-100">
                                    <div class="dynamic-section px-5 mt-4 py-4" :class="field_index > 0 && is_approvers_mandatory ? 'bg-grey' : ''" v-for="(field, field_index) in template_details" :key="field_index">
                                        <div class="infoHeader mt-2">
                                            <div class="descriptionheader">
                                                <div class="description-text-header-left">
                                                    <h5 class="font-weight-bold text-black whiteSpace" :title="field.part_name">{{ field.part_name.split('').length > 1 ?  field.part_name[0].toUpperCase() +''+ field.part_name.slice(1,) : field.part_name[0].toUpperCase()}}</h5>
                                                </div>
                                                <div class="description-text-header-right" v-if="is_approvers_mandatory && field_index > 0"></div>
                                                <div class="description-text-header-right" v-else>
                                                    <span class="collapse-addon" v-if="field.show">
                                                        <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" @click="ToggleParts(field)" alt="" style="top: 9px !important;transition:0.5s">
                                                    </span>
                                                    <span class="collapse-addon" v-else>
                                                        <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" alt="" @click="ToggleParts(field)" style="top: 9px !important;transform: rotate(180deg);transition:0.5s">
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-if="field.show">
                                            <div class="col-lg-12 col-md-12 col-sm-12 mt-5" v-for="(td, i) in field.parts_data" :key='i'>
                                                <div class="d-flex flex-column justify-content-start h-100" style="box-shadow: 0 0 2px 0 #939393;border: solid 0.3px #6c6d6f;border-radius: 6px !important;padding: 10px">
                                                    <div class="fw-600 pt-2 pb-2 fs-13 text-black d-inline-block w-100 overflowing-text" :title="td.name">{{td.name.split('').length > 1 ?  td.name[0].toUpperCase() +''+ td.name.slice(1,) : td.name[0].toUpperCase()}}<span class="text-danger" v-if="td.required == true"> *</span></div>
                                                    <div>
                                                        <!-- Short Answer -->
                                                        <input v-if="td.type == 'short_answer'"
                                                        class="border-bottom-custom inputFieldNew"
                                                        style="padding-right: 30px !important;"
                                                        type="text"
                                                        :disabled="field_index > 0 && is_approvers_mandatory"
                                                        v-model="td.answer"
                                                        maxlength="100"
                                                        placeholder="Enter Short Answer"
                                                        :name="'short_answer'+ i + '' +  field_index"
                                                        v-validate="td.required ? 'required' : ''"
                                                        data-vv-as="Short Answer"
                                                        />
                                                        <!-- API Call Dropdown -->
                                                        <div v-if="ticketType.name == 'Digicollect Product Template'">
                                                            <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                                v-model="td.answer"
                                                                class="diginew-multiselect border-bottom-custom mt-3"
                                                                :loading="apicall_loading"
                                                                :options="scm_products_options"
                                                                :disabled="field_index > 0 && is_approvers_mandatory"
                                                                :searchable="true" style="width: 250px !important"
                                                                :close-on-select="true"
                                                                :name="'apidrop_down'+ i + '' +  field_index"
                                                                track-by="_id"
                                                                @close="insertMultiProductTag(td.answer)"
                                                                :show-labels="false"
                                                                @search-change="searchTemplateApiDD"
                                                                @open="getTemplateApiDD"
                                                                :allow-empty="false"
                                                                :multiple="false"
                                                                :options-limit="3000"
                                                                :max-height="200"
                                                                v-validate="td.required ? 'required' : ''"
                                                                :clear-on-select="false"
                                                                label="name"
                                                                :internal-search="true"
                                                                :show-no-results="true"
                                                                :hide-selected="false"
                                                                >
                                                                    <template slot="placeholder">
                                                                        <span class="diginewhelp-multiselect">Select Product</span>
                                                                    </template>
                                                                    <template slot="afterList">
                                                                        <div v-observe-visibility="reachedEndOfApiDD" />
                                                                    </template>
                                                                    <template slot="noResult">
                                                                        <div v-if="scm_products_options.length">
                                                                            <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                                <div></div>
                                                                                <div></div>
                                                                                <div></div>
                                                                                <div></div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                                    </template>
                                                            </multiselect>
                                                        </div>
                                                        <div v-else>
                                                            <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                                v-model="td.answer"
                                                                class="diginew-multiselect border-bottom-custom mt-3"
                                                                :loading="apicall_loading"
                                                                :options="scm_products_options"
                                                                :searchable="true" style="width: 250px !important"
                                                                :disabled="field_index > 0 && is_approvers_mandatory"
                                                                :close-on-select="true"
                                                                :name="'apidrop_down'+ i + '' +  field_index"
                                                                :show-labels="false"
                                                                @search-change="searchApiDD"
                                                                @open="getApiDD"
                                                                :allow-empty="false"
                                                                @close="insertMultiProductTag(td.answer)"
                                                                :multiple="false"
                                                                :options-limit="3000"
                                                                :max-height="200"
                                                                v-validate="td.required ? 'required' : ''"
                                                                :clear-on-select="false"
                                                                label="name"
                                                                :internal-search="true"
                                                                :show-no-results="true"
                                                                :hide-selected="false"
                                                                >
                                                                    <template slot="placeholder">
                                                                        <span class="diginewhelp-multiselect">Select Product</span>
                                                                    </template>
                                                                    <template slot="afterList">
                                                                        <div v-observe-visibility="reachedEndOfApiDD" />
                                                                    </template>
                                                                    <template slot="noResult">
                                                                        <div v-if="scm_products_options.length">
                                                                            <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                                <div></div>
                                                                                <div></div>
                                                                                <div></div>
                                                                                <div></div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                                    </template>
                                                            </multiselect>
                                                        </div>
                                                        <!-- Tags -->
                                                        <div v-if="td.type == 'tag'">
                                                            <vue-tags-input :name="'tags'+  i + '' +  field_index"
                                                            data-vv-as="Tags" v-model="td.entered_tag" v-validate="td.required && td.answer.length == 0 ? 'required' : ''" 
                                                            class="multi_part-sec border-bottom-custom inputFieldNew-tags create-edit-ticket-tags rel-x2 mt-3" :tags="td.answer" :disabled="field_index > 0 && is_approvers_mandatory"
                                                            @tags-changed="tagsChangeMultiData($event, field_index, i, 'by-field')" maxlength="40" 
                                                            :placeholder="ticketType.name == 'Digicollect Product Template' || ticketType.name == 'Product Bug Template' ? 'Add Custom Tags' : 'Enter Tags Here'" 
                                                            id='to_email' :delete-on-backspace="false" />
                                                        </div>
                                                        <!-- Radiobutton -->
                                                        <el-radio-group 
                                                            v-if="td.type == 'radio_button'" class="mt-5 mob-issue-fix w-100" v-model="td.answer" 
                                                            v-validate="td.required ? 'required' : ''" :name="'radio_button'+ i + '' +  field_index" 
                                                            data-vv-as="Radio Button" :disabled="field_index > 0 && is_approvers_mandatory">
                                                            <div class="row">
                                                                <el-radio class="col-xl-2 col-lg-2 col-md-6 col-sm-6 text-capitalize d-flex word-wrap" :label="radio_options" v-for="(radio_options, ri) in td.possible_values" :key="ri">
                                                                    {{radio_options}}
                                                                </el-radio>
                                                            </div>
                                                        </el-radio-group>
                                                        <!-- Checkbox -->
                                                        <el-checkbox-group 
                                                            v-if="td.type == 'check_box'" class="refund-checkbox mt-4 w-100" 
                                                            v-model="td.answer" v-validate="td.required ? 'required' : ''" :name="'check_box'+ i + '' +  field_index" 
                                                            data-vv-as="Check Box" :disabled="field_index > 0 && is_approvers_mandatory">
                                                            <div class="row">
                                                                <el-checkbox class="text-capitalize col-xl-2 col-lg-2 col-md-6 col-sm-6 d-flex word-wrap" :label="check_options" v-for="(check_options, ci) in td.possible_values" :key="ci">
                                                                    {{check_options}}
                                                                </el-checkbox>
                                                            </div>
                                                        </el-checkbox-group>
                                                        <!-- Date -->
                                                        <date-picker v-if="td.type == 'date'"
                                                            class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor" placeholder="Enter the date"
                                                            v-validate="td.required ? 'required' : ''" :disabled="field_index > 0 && is_approvers_mandatory"
                                                            :name="'date'+ i + '' +  field_index"
                                                            data-vv-as="Date"
                                                            value-type="format" :editable="true"
                                                            format="MM/DD/YYYY" type="date" lang="en" v-model="td.answer"
                                                            style="border:none !important">
                                                        </date-picker>
                                                        <!-- Time -->
                                                        <date-picker v-if="td.type == 'time'"
                                                            v-model="td.answer" :disabled="field_index > 0 && is_approvers_mandatory"
                                                            format="hh:mm A"
                                                            :name="'time'+ i + '' +  field_index"
                                                            data-vv-as="Time"
                                                            class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon"
                                                            type="time"
                                                            placeholder="Enter the time"
                                                            lang="en"
                                                            value-type="format"
                                                            :clearable="false"
                                                            :editable="true"
                                                            @confirm="HandleTimeEventMultiPart($event, field_index, i, 'time')"
                                                            :minute-step="1"
                                                            confirm
                                                            confirm-text="APPLY"
                                                            v-validate="td.required ? 'required' : ''"
                                                        ></date-picker>
                                                        <!-- Date and time -->
                                                        <div class="d-flex align-items-center mt-1" v-if="td.type == 'date_time'">
                                                            <div class="row">
                                                                <date-picker v-if="td.type == 'date_time'"
                                                                    class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor col-lg-6 col-md-6 col-sm-12" placeholder="Enter the date"
                                                                    v-validate="td.required ? 'required' : ''"
                                                                    :name="'date_time'+ i + '' +  field_index"
                                                                    data-vv-as="Date" :disabled="field_index > 0 && is_approvers_mandatory"
                                                                    value-type="format" :editable="true"
                                                                    format="MM/DD/YYYY" type="date" lang="en" v-model="td.date"
                                                                    style="border:none !important">
                                                                </date-picker>
                                                                <date-picker v-if="td.type == 'date_time'"
                                                                    v-model="td.time"
                                                                    format="hh:mm a"
                                                                    :name="'date_time'+ i + '' +  field_index"
                                                                    data-vv-as="Time"
                                                                    class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-disabled date-picker-clock-icon col-lg-6 col-md-6 col-sm-12"
                                                                    type="time"
                                                                    placeholder="Enter the time"
                                                                    lang="en" :disabled="field_index > 0 && is_approvers_mandatory"
                                                                    value-type="format"
                                                                    :clearable="false"
                                                                    :editable="true"
                                                                    :minute-step="1"
                                                                    confirm
                                                                    @confirm="HandleTimeEventMultiPart($event, field_index, i, 'date_time')"
                                                                    confirm-text="APPLY"
                                                                    v-validate="td.required ? 'required' : ''"
                                                                ></date-picker>
                                                            </div>
                                                            <!-- <div class="w-50">
                                                                
                                                            </div> -->
                                                        </div>
                                                        <!-- Long Answer -->
                                                        <textarea 
                                                            placeholder="Enter Long Answer"  maxlength="500" v-validate="td.required ? 'required' : ''" 
                                                            :name="'long_answer'+ i + '' +  field_index" :disabled="field_index > 0 && is_approvers_mandatory" data-vv-as="Long Answer" v-if="td.type == 'long_answer'" v-model="td.answer" 
                                                            class="desc-textarea mt-3"></textarea>
                                                        <!-- Dropdown -->
                                                        <multiselect
                                                            v-if="td.type == 'drop_down' && td.is_api_call_required == false"
                                                            v-validate="td.required ? 'required' : ''" style="width: 250px !important"
                                                            class="diginew-multiselect border-bottom-custom mt-3"
                                                            :name="'drop_down'+ i + '' +  field_index"
                                                            data-vv-as="Drop Down"
                                                            v-model="td.answer" :disabled="field_index > 0 && is_approvers_mandatory"
                                                            :options="td.possible_values"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :show-labels="false"
                                                        >
                                                            <template slot="placeholder">
                                                                <span class="diginewhelp-multiselect">Select Dropdown</span>
                                                            </template>
                                                        </multiselect>
                                                        <div v-if="td.type == 'location'">
                                                            <div class="digi-table-loader d-flex justify-content-center" v-if="location_loader" id="spinner" style="margin: 0 auto;position:absolute">
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                            </div>
                                                            <div class="form-group contactGroup pt-0">
                                                                <div class="d-flex align-items-center">
                                                                    <div class="form-group gMap" style="position:relative;width:100%;padding-top:1.3rem !important">
                                                                        <input class="inputFieldNew overflowing-text mt-0 border-bottom-custom" style="padding-right: 30px !important;" 
                                                                        :name="'location' + i + '' +  field_index" type="text" disabled v-model="td.location_details.location_vmodel" 
                                                                        placeholder="Enter Location" />
                                                                        <div class="d-flex">
                                                                            <i class="icon icon-map-marker color-blue" style="position: absolute;right: 5px;bottom: 9px;"></i>
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="field_index > 0 && is_approvers_mandatory" class="gps-logo" :id="'DisableOnClick' + i + field_index" style="opacity: .5;cursor: not-allowed;">
                                                                        <i class="icon-crosshairs-gps color-blue" ></i>
                                                                    </div>
                                                                    <div v-else class="gps-logo pointer" :id="'DisableOnClick' + i + field_index" @click="getMultiPartLocation(field_index ,i)">
                                                                        <i class="icon-crosshairs-gps color-blue" ></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="td.statement">
                                                            <textarea v-model="td.reason" v-validate="td.required ? 'required' : ''" class="text-reason" :name="`reason${i}${field_index}`" style="resize: none;" data-vv-as="Reason" placeholder="Enter a reason"></textarea>
                                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has(`reason${i}${field_index}`)">{{errors.first(`reason${i}${field_index}`)}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="position-absolute">
                                                    <!-- Short Answer Validations -->
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('short_answer'+ i + '' +  field_index)">{{errors.first('short_answer'+ i + '' +  field_index)}}</span>
                                                    <!-- Long Answer Validations -->
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('long_answer'+ i + '' +  field_index)">{{errors.first('long_answer'+ i + '' +  field_index)}}</span>
                                                    <!-- Check box Validations -->
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('check_box'+ i + '' +  field_index)">{{errors.first('check_box'+ i + '' +  field_index)}}</span>
                                                    <!-- Radio check Validations -->
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('radio_button'+ i + '' +  field_index)">{{errors.first('radio_button'+ i + '' +  field_index)}}</span>
                                                    <!-- Drop down Validations -->
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('drop_down'+ i + '' +  field_index)">{{errors.first('drop_down'+ i + '' +  field_index)}}</span>
                                                    <!-- SCM Products Drop down Validations -->
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('apidrop_down'+ i + '' +  field_index)">The Dropdown Field Is Required</span>
                                                    <!-- Tags Validations -->
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('tags'+ i + '' +  field_index)">{{errors.first('tags'+ i + '' +  field_index)}}</span>
                                                    <!-- Date Validations -->
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date'+ i + '' +  field_index)">{{errors.first('date'+ i + '' +  field_index)}}</span>
                                                    <!-- Time Validations -->
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('time'+ i + '' +  field_index)">{{errors.first('time'+ i + '' +  field_index)}}</span>
                                                    <!-- Date And Time Validations -->
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date_time'+ i + '' +  field_index)">The Date and Time field required</span>
                                                    <!-- Location Validations -->
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.error">The Location field is required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="general-section pt-2 pb-6 mt-4 d-flex justify-content-center" v-if="(is_approvers_mandatory && field_index == 0) || (!is_approvers_mandatory)">
                                            <div class="attachment-bg w-100 attachment-bg-new pb-8">
                                                <div class="d-flex justify-content-center mt-4">
                                                    <div class="img-upload pl-sm-15 pr-sm-15 pt-3 pb-3 text-center bg-white" @drop="dropAttachment($event, field_index)" @dragover="dragOverAttachment($event)">
                                                        <span class="pr-4 hide-on-mob">Drag and Drop Files Here</span>
                                                        <span class="pr-4 hide-on-mob" style="font-weight:400 !important;">or</span>
                                                        <label class="choose-file ml-2 btn-upload" v-if="field.attach_files.length < 10">
                                                            <!-- <img src="/static/images/menu_icons/upload-icon-button.png" width="25" height="25" alt=""> -->
                                                            <input id="multiple" type="file" @change="uploadAttachmentByPart($event, field_index)" accept=".pdf,.doc,.xls,image/*">
                                                            Browse Files
                                                        </label>
                                                        <label class="choose-file ml-2 cursor-notallowed btn-upload-disabled" v-else>
                                                            <!-- <img src="/static/images/menu_icons/upload-icon-button.png" width="25" height="25" alt=""> -->
                                                            <!-- <input id="multiple" type="file" @change="uploadAttachmentByPart($event, field_index)" accept=".pdf,.doc,.xls,image/*"> -->
                                                            Browse Files
                                                        </label>
                                                        <span class="pr-4 pl-4" style="font-weight:400 !important;">or</span>
                                                        <span class="pr-4 pointer">
                                                            <img width="50" @click="openCaptureImageMulti(field_index)" src="/static/images/camera.svg" alt="Capture Image" v-if="field.attach_files.length < 10"/>
                                                            <img width="50" class="cursor-notallowed" style="opacity:.5 !important" src="/static/images/camera.svg" alt="Capture Image"  v-else/>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="d-flex flex-wrap align-items-center mt-4">
                                                    <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in field.attach_files" :key="index">
                                                        <div class="d-flex align-items-center mt-6 file-bg">
                                                            <div class="d-flex align-items-center" style="width:90%">
                                                                <div>
                                                                    <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.mp3')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" style="width:40px; height:40px"/>
                                                                    <img v-else-if="attachment.name.endsWith('.mp4')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" style="width:40px; height:40px"/>
                                                                    <img v-else-if="attachment.name.endsWith('.MOV') || attachment.name.endsWith('.mov')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" style="width:40px; height:40px"/>
                                                                    <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/>
                                                                    <!-- <img v-else-if="attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')"  src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" style="width:40px; height:40px"/> -->
                                                                </div>
                                                                <div class="col">
                                                                    <div class="d-flex justify-content-between">
                                                                        <el-tooltip :content="attachment.name" placement="top">
                                                                            <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                {{attachment.name}}
                                                                            </div>
                                                                        </el-tooltip>
                                                                    </div>
                                                                    <div v-if="attachment.uploading || attachment.url == undefined">
                                                                        <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                    </div>
                                                                    <div class="d-flex justify-content-between">
                                                                        <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}...</div>
                                                                        <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                        <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="pointer ml-3" style="width:10%" @click="deleteAttachmentByPart(attachment,field_index)">
                                                                <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                                <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url && attachment.uploading == false"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <modal
                                                    transition="nice-modal-fade"
                                                    class="new-modal-default emergency-contact-list"
                                                    :name="`capture-image${field_index}`"
                                                    v-if="show_capture_image_multi"
                                                    :delay="100"
                                                    height="auto"
                                                    :width="400"
                                                    :adaptive="true" :scrollable="true"
                                                >
                                                    <div class="v-modal-content" style="border-radius: 15px;background-color: #ebf3ff !important;">
                                                        <div class="v-modal-body">
                                                            <div class="v-modal-layout d-flex justify-content-center">
                                                                <div id="app" class="web-camera-container mt-10">
                                                                    <div v-show="isCameraOpen && isLoading" >
                                                                        <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                                                                    </div>
                                                                    <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                                                        <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                                                        <video v-show="!isPhotoTaken" ref="camera_capture" :width="250" :height="250" autoplay></video>
                                                                        <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="250" :height="250"></canvas>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                                                            <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important;" @click="hideViewMultiPart(field_index)">CANCEL</a>
                                                            <button :disabled="!(isCameraOpen && !isLoading)" v-if="isCameraOpen && !isPhotoTaken" @click="takePhotoMultiPart(field_index)" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                                                Capture
                                                            </button>
                                                            <button :disabled="!(isCameraOpen && !isLoading)" v-if="isPhotoTaken && isCameraOpen" @click="downloadImageByPart(field_index)" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                                                Upload
                                                            </button>
                                                        </div>
                                                    </div>
                                                </modal>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                <div class="row w-100" v-if="template_details.length > 0 && ticket_details.template_type == 'default'">
                                    <div class="col-lg-12 col-md-12 col-sm-12 mt-5" v-for="(td, i) in template_details" :key='i'>
                                        <!-- <span class="fs-13 fw-600 text-black">
                                            {{td.name}}<span class="text-danger pl-1" v-if="td.required == true"> *</span>
                                        </span> -->
                                        <div class="d-flex flex-column justify-content-start h-100" style="box-shadow: 0 0 2px 0 #939393;border: solid 0.3px #6c6d6f;border-radius: 6px !important;padding: 10px">
                                            <div class="fw-600 pt-2 pb-2 fs-13 text-black d-inline-block w-100 overflowing-text" :title="td.name">{{td.name.split('').length > 1 ?  td.name[0].toUpperCase() +''+ td.name.slice(1,) : td.name[0].toUpperCase()}}<span class="text-danger" v-if="td.required == true"> *</span></div>
                                            <div>
                                                <!-- Short Answer -->
                                                <input v-if="td.type == 'short_answer'"
                                                class="border-bottom-custom inputFieldNew"
                                                style="padding-right: 30px !important;"
                                                type="text"
                                                v-model="td.answer"
                                                maxlength="100"
                                                placeholder="Enter Short Answer"
                                                :name="'short_answer'+ i"
                                                v-validate="td.required ? 'required' : ''"
                                                data-vv-as="Short Answer"
                                                />

                                                <!-- API Call Dropdown -->
                                                <!-- @open="getTicketTemplate"
                                                    @close="checkTicketType"
                                                    @select="selectedTemplate"-->
                                                <div v-if="ticketType.name == 'Digicollect Product Template'">
                                                    <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                        v-model="td.answer" style="max-width:250px !important"
                                                        class="diginew-multiselect border-bottom-custom mt-3"
                                                        :loading="apicall_loading"
                                                        :options="scm_products_options"
                                                        :searchable="true"
                                                        :close-on-select="true"
                                                        :name="'apidrop_down'+ i"
                                                        track-by="_id"
                                                        @close="insertProductTag(td.answer)"
                                                        :show-labels="false"
                                                        @search-change="searchTemplateApiDD"
                                                        @open="getTemplateApiDD"
                                                        :allow-empty="false"
                                                        :multiple="false"
                                                        :options-limit="3000"
                                                        :max-height="200"
                                                        v-validate="td.required ? 'required' : ''"
                                                        :clear-on-select="false"
                                                        label="name"
                                                        :internal-search="true"
                                                        :show-no-results="true"
                                                        :hide-selected="false"
                                                        >
                                                            <template slot="placeholder">
                                                                <span class="diginewhelp-multiselect">Select Product</span>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div v-observe-visibility="reachedEndOfApiDD" />
                                                            </template>
                                                            <template slot="noResult">
                                                                <div v-if="scm_products_options.length">
                                                                    <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                        <div></div>
                                                                        <div></div>
                                                                        <div></div>
                                                                        <div></div>
                                                                    </div>
                                                                </div>
                                                                <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                            </template>
                                                    </multiselect>
                                                </div>
                                                <div v-else>
                                                    <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                        v-model="td.answer"
                                                        style="max-width:250px !important"
                                                        class="diginew-multiselect border-bottom-custom mt-3"
                                                        :loading="apicall_loading"
                                                        :options="scm_products_options"
                                                        :searchable="true"
                                                        :close-on-select="true"
                                                        :name="'apidrop_down'+ i"
                                                        :show-labels="false"
                                                        @search-change="searchApiDD"
                                                        @open="getApiDD"
                                                        @close="insertProductTag(td.answer)"
                                                        :allow-empty="false"
                                                        :multiple="false"
                                                        :options-limit="3000"
                                                        :max-height="200"
                                                        v-validate="td.required ? 'required' : ''"
                                                        :clear-on-select="false"
                                                        label="name"
                                                        :internal-search="true"
                                                        :show-no-results="true"
                                                        :hide-selected="false"
                                                        >
                                                            <template slot="placeholder">
                                                                <span class="diginewhelp-multiselect">Select Product</span>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div v-observe-visibility="reachedEndOfApiDD" />
                                                            </template>
                                                            <template slot="noResult">
                                                                <div v-if="scm_products_options.length">
                                                                    <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                        <div></div>
                                                                        <div></div>
                                                                        <div></div>
                                                                        <div></div>
                                                                    </div>
                                                                </div>
                                                                <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                            </template>
                                                    </multiselect>
                                                </div>
                                                <!-- Tags -->
                                                <div v-if="td.type == 'tag'">
                                                    <vue-tags-input :name="'tags'+ i"
                                                    data-vv-as="Tags" v-model="td.entered_tag" v-validate="td.required && td.answer.length == 0 ? 'required' : ''" class="multi_part-sec border-bottom-custom inputFieldNew-tags create-edit-ticket-tags rel-x2 mt-3" :tags="td.answer" @tags-changed="tagsChangeData($event, i, 'by-field')" maxlength="40" :placeholder="ticketType.name == 'Digicollect Product Template' || ticketType.name == 'Product Bug Template' ? 'Add Custom Tags' : 'Enter Tags Here'" id='to_email' :delete-on-backspace="false" />
                                                </div>
                                                <!-- Radiobutton -->
                                                <el-radio-group v-if="td.type == 'radio_button'" class="mt-5 mob-issue-fix w-100" v-model="td.answer" v-validate="td.required ? 'required' : ''" :name="'radio_button'+ i" data-vv-as="Radio Button">
                                                    <div class="row">
                                                        <el-radio class="col-xl-2 col-lg-2 col-md-3 col-sm-6 text-capitalize d-flex word-wrap" :label="radio_options" v-for="(radio_options, ri) in td.possible_values" :key="ri">
                                                            {{radio_options}}
                                                        </el-radio>
                                                    </div>
                                                </el-radio-group>
                                                <!-- Checkbox -->
                                                <el-checkbox-group v-if="td.type == 'check_box'" class="refund-checkbox mt-4  w-100" v-validate="td.required ? 'required' : ''" :name="'check_box'+ i" data-vv-as="Check Box" v-model="td.answer">
                                                    <div class="row">
                                                        <!-- <div> -->
                                                            <el-checkbox class="text-capitalize col-xl-2 col-lg-2 col-md-3 col-sm-6 d-flex word-wrap" :label="check_options" v-for="(check_options, ci) in td.possible_values" :key="ci">
                                                                {{check_options}}
                                                            </el-checkbox>
                                                        <!-- </div> -->
                                                    </div>
                                                </el-checkbox-group>
                                                <!-- Date -->
                                                <date-picker v-if="td.type == 'date'"
                                                class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor" placeholder="Enter the date"
                                                    v-validate="td.required ? 'required' : ''"
                                                    :name="'date'+ i"
                                                    data-vv-as="Date"
                                                    value-type="format"
                                                    :editable="true"
                                                    format="MM/DD/YYYY" type="date" lang="en" v-model="td.answer"
                                                    style="border:none !important">
                                                </date-picker>
                                                <!-- Time -->
                                                <date-picker v-if="td.type == 'time'"
                                                    v-model="td.answer"
                                                    format="hh:mm A"
                                                    :name="'time'+ i"
                                                    data-vv-as="Time"
                                                    class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon"
                                                    type="time"
                                                    placeholder="Enter the time"
                                                    lang="en"
                                                    value-type="format"
                                                    :clearable="false"
                                                    :editable="true"
                                                    :minute-step="1"
                                                    @confirm="HandleTimeEvent($event, i, 'time')"
                                                    confirm
                                                    confirm-text="APPLY"
                                                    v-validate="td.required ? 'required' : ''"
                                                ></date-picker>
                                                <!-- Date and time -->
                                                <div class="d-flex align-items-center mt-3" v-if="td.type == 'date_time'">
                                                    <div class="row">
                                                        <date-picker v-if="td.type == 'date_time'"
                                                            class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor col-lg-6 col-md-6 col-sm-12" placeholder="Enter the date"
                                                            v-validate="td.required ? 'required' : ''"
                                                            :name="'date_time'+ i"
                                                            data-vv-as="Date" :editable="true"
                                                            value-type="format"
                                                            format="MM/DD/YYYY" type="date" lang="en" v-model="td.date"
                                                            style="border:none !important">
                                                        </date-picker>
                                                        <date-picker v-if="td.type == 'date_time'"
                                                            v-model="td.time"
                                                            format="hh:mm A"
                                                            :name="'date_time'+ i"
                                                            data-vv-as="Time"
                                                            class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon col-lg-6 col-md-6 col-sm-12"
                                                            type="time"
                                                            placeholder="Enter the time"
                                                            lang="en"
                                                            value-type="format"
                                                            :clearable="false"
                                                            :editable="true"
                                                            :minute-step="1"
                                                            @confirm="HandleTimeEvent($event, i, 'date_time')"
                                                            confirm
                                                            confirm-text="APPLY"
                                                            v-validate="td.required ? 'required' : ''"
                                                        ></date-picker>
                                                    </div>
                                                </div>
                                                <!-- Long Answer -->
                                                <textarea placeholder="Enter Long Answer"  maxlength="500" v-validate="td.required ? 'required' : ''" :name="'long_answer'+ i" data-vv-as="Long Answer" v-if="td.type == 'long_answer'" v-model="td.answer" class="desc-textarea mt-3"></textarea>
                                                <!-- Dropdown -->
                                                <multiselect
                                                    v-if="td.type == 'drop_down' && td.is_api_call_required == false"
                                                    v-validate="td.required ? 'required' : ''"
                                                    class="diginew-multiselect border-bottom-custom mt-3"
                                                    :name="'drop_down'+ i" style="width: 250px !important"
                                                    data-vv-as="Drop Down"
                                                    v-model="td.answer"
                                                    :options="td.possible_values"
                                                    :searchable="true"
                                                    :close-on-select="true"
                                                    :show-labels="false"
                                                >
                                                    <template slot="placeholder">
                                                        <span class="diginewhelp-multiselect">Select Dropdown</span>
                                                    </template>
                                                </multiselect>
                                                <div v-if="td.type == 'location'">
                                                    <div class="digi-table-loader d-flex justify-content-center" v-if="location_loader" id="spinner" style="margin: 0 auto;position:absolute;left:40%">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                    <div class="form-group contactGroup pt-0">
                                                        <div class="d-flex align-items-center">
                                                            <div class="form-group gMap" style="position:relative;width:100%;padding-top:1.3rem !important">
                                                                <input class="inputFieldNew overflowing-text mt-0 border-bottom-custom" style="padding-right: 30px !important;" :name="'location' + i" type="text" disabled v-model="td.location_details.location_vmodel" placeholder="Enter Location" />
                                                                <div class="d-flex">
                                                                    <i class="icon icon-map-marker color-blue" style="position: absolute;right: 5px;bottom: 9px;"></i>
                                                                </div>
                                                            </div>
                                                            <div class="gps-logo pointer" :id="'DisableOnClick' + i" @click="getLocation(i)">
                                                                <i class="icon-crosshairs-gps color-blue" ></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="td.statement">
                                                    <textarea v-model="td.reason" v-validate="td.required ? 'required' : ''" class="text-reason" :name="`reason${i}`" style="resize: none;" data-vv-as="Reason" placeholder="Enter a reason"></textarea>
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has(`reason${i}`)">{{errors.first(`reason${i}`)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <!-- Short Answer Validations -->
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('short_answer'+ i)">{{errors.first('short_answer'+ i)}}</span>
                                            <!-- Long Answer Validations -->
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('long_answer'+ i)">{{errors.first('long_answer'+ i)}}</span>
                                            <!-- Check box Validations -->
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('check_box'+ i)">{{errors.first('check_box'+ i)}}</span>
                                            <!-- Radio check Validations -->
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('radio_button'+ i)">{{errors.first('radio_button'+ i)}}</span>
                                            <!-- Drop down Validations -->
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('drop_down'+ i)">{{errors.first('drop_down'+ i)}}</span>
                                            <!-- SCM Products Drop down Validations -->
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('apidrop_down'+ i)">The Dropdown Field Is Required</span>
                                            <!-- Tags Validations -->
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('tags'+ i)">{{errors.first('tags'+ i)}}</span>
                                            <!-- Date Validations -->
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date'+ i)">{{errors.first('date'+ i)}}</span>
                                            <!-- Time Validations -->
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('time'+ i)">{{errors.first('time'+ i)}}</span>
                                            <!-- Date And Time Validations -->
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date_time'+ i)">The Date and Time field required</span>
                                            <!-- Location Validations -->
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.error">The Location field is required</span>
                                        </div>
                                    </div>
                                </div>   
                            </div>
                            <div v-if="ticket_details.template_type == 'default'">
                                <div v-if="!is_view_screen" class="attachment mt-10 mx-3">
                                    <div class="mx-3">
                                        <div class="attatchment-new-pm d-flex justify-content-center mt-4">
                                            <div class="img-upload pt-3 text-center bg-white">
                                                <span class="pr-4 hide-on-mob">Drag and Drop Files Here</span>
                                                <span class="pr-4 hide-on-mob" style="font-weight:400 !important;">or</span>
                                                <label class="choose-file mt-1">
                                                    <input type="file" id="multiple" multiple @change="uploadAttachment" accept="image/*">
                                                    Browse Files
                                                </label>
                                                <span class="pr-4 pl-4" style="font-weight:400 !important;">or</span>
                                                <span class="pr-4 pointer">
                                                    <img @click="openCaptureImage" width="50" src="/static/images/camera_black.svg" alt="Capture Image" />
                                                </span>
                                            </div>
                                        </div>
                                        <div class="example-full">
                                            <div class="btn-group" style="display: none;">
                                                <file-upload
                                                    class="btn btn-primary dropdown-toggle"
                                                    :multiple="multiple"
                                                    :directory="directory"
                                                    :size="size || 0"
                                                    :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                                                    :headers="headers"
                                                    :data="data"
                                                    :drop="drop"
                                                    :drop-directory="dropDirectory"
                                                    :add-index="addIndex"
                                                    v-model="temp_attachments"
                                                    @input-file="inputFile"
                                                    ref="upload"
                                                    webkitdirectory mozdirectory>
                                                    <i class="icon icon-plus"></i>
                                                    Select
                                                </file-upload>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap align-items-center mt-4">
                                            <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in attachments" :key="index">
                                                <div class="d-flex align-items-center mt-6 file-bg">
                                                    <div class="d-flex align-items-center" style="width:80%">
                                                        <div>
                                                            <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                            <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                            <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.jpg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                            <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                            <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                            <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                        </div>
                                                        <div class="col">
                                                            <div class="d-flex justify-content-between">
                                                                <el-tooltip :content="attachment.name" placement="top">
                                                                    <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                        {{attachment.name}}
                                                                    </div>
                                                                </el-tooltip>
                                                            </div>
                                                            <div v-if="attachment.uploading || attachment.url == undefined">
                                                                <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                            </div>
                                                            <div class="d-flex justify-content-between">
                                                                <div class="text-danger pl-0 fw-500" v-if="attachment.error">{{attachment.error}}...</div>
                                                                <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                <div class="fw-500" v-if="attachment.size">({{attachment.size | prettyBytes}})</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="pointer" style="width:10%; z-index: 9999; margin-left: 15px;" @click="deleteAttachment(attachment,index)">
                                                        <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                        <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url && attachment.uploading == false"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <modal
                                        transition="nice-modal-fade"
                                        class="new-modal-default emergency-contact-list"
                                        name="capture-image"
                                        v-if="show_capture_image"
                                        :delay="100"
                                        height="auto"
                                        :width="400"
                                        :adaptive="true" :scrollable="true"
                                    >
                                        <div class="v-modal-content" style="border-radius: 15px;background-color: #ebf3ff !important;">
                                            <div class="v-modal-body">
                                                <div class="v-modal-layout d-flex justify-content-center">
                                                    <div id="app" class="web-camera-container mt-10">
                                                        <div v-show="isCameraOpen && isLoading" >
                                                            <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                                                        </div>

                                                        <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                                            <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                                            <video v-show="!isPhotoTaken" ref="camera_capture" :width="250" :height="250" autoplay></video>
                                                            <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="250" :height="250"></canvas>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                                                <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important;" @click="hideView()">CANCEL</a>
                                                <button :disabled="!(isCameraOpen && !isLoading)" v-if="isCameraOpen && !isPhotoTaken" @click="takePhoto" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                                    Capture
                                                </button>
                                                <button :disabled="!(isCameraOpen && !isLoading)" v-if="isPhotoTaken && isCameraOpen" @click="downloadImage" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                                    Upload
                                                </button>
                                            </div>
                                        </div>
                                    </modal>
                                </div>
                                <div v-else class="">
                                    <h1 class="fs-14 fw-600 px-3 mb-0">
                                        Attachments ({{attachments.length}})
                                    </h1>
                                    <div class="d-flex flex-wrap align-items-center">
                                        <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in attachments" :key="index">
                                            <div class="d-flex align-items-center mt-6 file-bg" style="border-radius: 4px;box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);background-color: #f5f6f9;">
                                                <div class="d-flex align-items-center" style="width:95%">
                                                    <div>
                                                        <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                        <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                        <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.jpeg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                        <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                        <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                        <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                    </div>
                                                    <div class="col">
                                                        <div class="d-flex justify-content-between">
                                                            <el-tooltip :content="attachment.name" placement="top">
                                                                <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                    {{attachment.name}}
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-if="attachment.uploading || attachment.url == undefined">
                                                            <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                        </div>
                                                        <div class="d-flex justify-content-between">
                                                            <div class="text-danger pl-0 fw-500" v-if="attachment.error">{{attachment.error}}...</div>
                                                            <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                            <div class="fw-500" v-if="attachment.size">({{attachment.size | prettyBytes}})</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a :href="attachment.url" download style="text-decoration: none; z-index: 55">
                                                    <i class="icon icon-download text-new-blue"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="is_view_screen" class="d-flex align-items-center justify-content-center mt-10 mb-4">
                                <button type="button" class="btn btn-new-primary" @click="goToListView" >Close</button>
                            </div>
                            <div v-else class="d-flex align-items-center justify-content-center mt-10 mb-4">
                                <button type="button" class="btn btn-danger-new fw-500 text-capitalize w-130px" @click="goToListView" >Cancel</button>
                                <button type="button" class="btn btn-success text-capitalize fw-500 ml-4 text-white w-130px" :class="{'text-align-left': is_api_calling}" :disabled="is_api_calling || save_loader" @click="createSuccess">
                                    {{save_loader ? 'Saving' : 'Save & Send'}}
                                    <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:50px" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
	</div>
</template>
<script>
import FileUpload from 'vue-upload-component';
import {EventBus} from "../eventBus/nav-bar-event.js";
import UploadingAttachments from '@digicollect_front_end/digi-fe-library/src/components/mixins/attachments_handler.js'
import { HalfCircleSpinner } from "epic-spinners";
import VueTagsInput from "@johmun/vue-tags-input";
import { SweetModal } from 'sweet-modal-vue';
import attachments from '../mixins/attachments'
import facility_mgmt from '../mixins/facility_mgmt';
import ticket from '../mixins/ticket.js';
import crm from '../mixins/crm.js';
import scm from '../mixins/scm.js';
import moment from 'moment';
import axios from 'axios';
import time_utils from '../mixins/time_utils';
import { debounce } from 'lodash';
export default {
    mixins: [crm, scm, attachments, facility_mgmt, time_utils, ticket, UploadingAttachments],
    components:{
        SweetModal,
        FileUpload,
        VueTagsInput,
        HalfCircleSpinner
    },
    data(){
        return{
            success_msg:'',
            warning_msg:'',
            skip:0,
            limit:10,
            search_key:'',
            tag_location: '',
            facility_name: '',
            product_id: '',
            assigned_by: '',
            comments: '',
            assigned_by_name: '',
            department: {
                _id: '',
                name: ''
            },
            ticketType:'',
            assignment_details: {
                assigned_to: '',
                is_assigned: true,
                to: "person"
            },
            assign_options: [],
            date_and_time: {
                date: moment(new Date().toString()).format('MM/DD/YYYY'),
                time: moment(new Date().toString()).format('hh:mm a')
            },
            assign_a_ticket: false,
            department_options: [],
            priority: '',
            priority_options: ['High', 'Medium', 'Low'],
            reason_of_concern: '',
            notes: '',
            temp_attachments:[],
            accept: '*',
            extensions: '*',
            size: 1024 * 1024 * 10,
            multiple: true,
            directory: true,
            drop: true,
            dropDirectory: true,
            addIndex: false,
            thread: 3,
            name: 'file',
            postAction: '/upload/post',
            putAction: '/upload/put',
            headers: {
                'X-Csrf-Token': 'xxxx',
            },
            data: {
                '_csrf_token': 'xxxxxx',
            },
            autoCompress: 1024 * 1024,
            uploadAuto: false,
            isOption: false,
            attachments:[],
            singleAttachment:'',
            is_date: false,
            is_time: false,
            is_api_calling: false,
            departments_loading: false,
            department_count: 0,
            isVisible: false,
            scrollable: false,
            department_search_key: '',
            assign_visible: false,
            assign_scrollable: false,
            assign_loading: false,
            assign_count: 0,
            url_not_found: false,
            is_view_screen: false,
            assignment_details_id: '',
            ajax_call_inprogress: false,
            ticket_details : {
                ticket_number : '',
                ticket_id: '',
                ticket_status: '',
                template_type: ''
            },
            isCameraOpen: false,
            isPhotoTaken: false,
            isShotPhoto: false,
            isLoading: false,
            link: '#',
            show_capture_image: false,
            camera_selection: [],
            selected_camera_device: '',
            facility_id_not_active: false,

            //Ticket template fields
            ticket_type_loading:false,
            ticket_type_options:[],
            template_details: [],
            ticket_type_count: 0,
            ticketTemplateListScrollable: false,
            template_search_key: '',
            isVisibleTicket: false,
            apicall_loading: false,
            scm_products_options: [],
            scm_products_count: 0,
            temp_location: {
                address:"",
                city:"",
                country:"",
                full_address:"",
                location_vmodel:"",
                state:"",
                street1:"",
                township:"",
                zip_code:""
            },
            approvers_data: [],
            is_approvers_mandatory: false,
            approvers_options: [],
            load_template: true,
            save_loader: false,
            show_capture_image_multi: false
        }
    },
    methods:{
        ToggleParts(part){
            if(part.show){
                part.show = false
            } else {
                part.show = true
            }
            this.$forceUpdate();
        },
        removeApprovers(option){
            this.approvers_data.forEach((el,index)=>{
                if(el == option){
                    this.approvers_data.splice(index,1)
                }
            })
        },
        insertMultiProductTag(answer){
            this.template_details.forEach((x, x_index) => {
                x.parts_data.forEach((el, el_index) => {
                    if(el.type == "tag" && answer != ''){
                        let temp_ans = [...new Set(el.answer.map(x => x))];
                        temp_ans.shift()
                        temp_ans.unshift({
                            text: answer.name,
                            tiClasses: [
                                "ti-valid"
                            ]
                        })
                        this.tagsChangeMultiData(temp_ans, x_index, el_index, 'by-function')
                    }
                })
            })
            this.$forceUpdate()
        },
        tagsChangeMultiData(update_tag, part_index, index, mode){
            if(mode == 'by-field'){
                this.template_details[part_index].parts_data[index].answer = update_tag
            } else if(mode == 'by-function'){
                this.template_details[part_index].parts_data[index].answer = update_tag
                setTimeout(() => {
                    document.querySelector(".ti-tags").setAttribute("id", "fstprod");
                    document.getElementById("fstprod").firstChild.style.pointerEvents = 'none';
                    document.getElementById("fstprod").firstChild.lastChild.style.display = 'none';
                }, 500);
            }
            this.$forceUpdate()
        },
        HandleTimeEvent(event, indx, type){
            if(type == 'date_time'){
                if(event == ''){
                    this.template_details[indx].time = '12:00 am'
                }
            } else if(type == 'time'){
                if(event == ''){
                    this.template_details[indx].answer = '12:00 am'
                }
            }
            this.$forceUpdate()
        },
        HandleTimeEventMultiPart(event, part_index, indx, type){
            if(type == 'date_time'){
                if(event == ''){
                    this.template_details[part_index].parts_data[indx].time = '12:00 am'
                }
            } else if(type == 'time'){
                if(event == ''){
                    this.template_details[part_index].parts_data[indx].answer = '12:00 am'
                }
            }
            this.$forceUpdate()
        },
        goToTicketDetails(){
            if(this.ticket_details.template_type == 'default' || (this.ticket_details.template_type == 'multi_part' && this.ticket_details.ticket_status == 'closed')){
                this.$router.push('/ticketdetails/' + this.ticket_details.ticket_id);
                if(localStorage.getItem('newListData')){
                    let list_data = JSON.parse(localStorage.getItem('newListData'));
                    let new_data = {
                        approval: false,
                        is_parent_ticket: false,
                        name: `Ticket ${this.ticket_details.ticket_number}`,
                        subject: '',
                        ticket_id: this.ticket_details.ticket_id,
                        value: 'ticket-details',
                    }
                    list_data.list.push(new_data)
                    list_data.list = list_data.list.filter((value, index, self) =>
                        index === self.findIndex((t) => (
                            t.ticket_id === value.ticket_id
                        ))
                    )
                    list_data.selected = list_data.list.length - 1
                    localStorage.setItem('newListData', JSON.stringify(list_data))
                } else {
                    let list_data = {
                        list: [],
                        selected: 0,
                    }
                    let new_data = {
                        approval: false,
                        is_parent_ticket: false,
                        name: `Ticket ${this.ticket_details.ticket_number}`,
                        subject: '',
                        ticket_id: this.ticket_details.ticket_id,
                        value: 'ticket-details',
                    }
                    list_data.list.push(new_data)
                    list_data.list = list_data.list.filter((value, index, self) =>
                        index === self.findIndex((t) => (
                            t.ticket_id === value.ticket_id
                        ))
                    )
                    list_data.selected = list_data.list.length - 1
                    localStorage.setItem('newListData', JSON.stringify(list_data))
                }
            } else {
                this.$router.push({
                    path: `/ticketdetails/view/${this.ticket_details.ticket_id}`,
                    query: {
                        type: 'normal_ticket'
                    }
                });
            }
        },
        setPlace(place,index) {
            let address = place.formatted_address.split(", ");
            this.temp_location['street1'] =
                address[address.length - 6] || "";
            this.temp_location['township'] =
                address[address.length - 4] || "";
            this.temp_location['city'] = address[address.length - 3] || "";
            let statezip = address[address.length - 2]
                ? address[address.length - 2].split(" ")
                : ["", ""];
            if (statezip.length == 1) {
                if (statezip[0].match(/^[0-9]+$/)) {
                this.temp_location['zip_code'] = statezip[0];
                } else {
                this.temp_location['state'] = statezip[0];
                }
            } else {
                this.temp_location['zip_code'] = statezip[0].match(/^[0-9]+$/)
                ? statezip[0]
                : statezip[1].match(/^[0-9]+$/)
                ? statezip[1]
                : "";
                this.temp_location['state'] = statezip[0].match(/^[a-zA-Z]+$/)
                ? statezip[0]
                : statezip[1].match(/^[a-zA-Z]+$/)
                ? statezip[1]
                : "";
            }
            if (address[address.length - 1].includes("-")) {
                let countrySelected = address[address.length - 1].split(" - ");
                countrySelected.forEach(x => {
                if (this.countries.includes(x)) {
                        this.temp_location['country'] = x;
                } else {
                        this.temp_location['country'] = "";
                }
                });
            } else {
                this.temp_location['country'] = address[address.length - 1];
            }
            this.temp_location['location_vmodel'] = place.formatted_address;
            this.temp_location['full_address'] = place.formatted_address;
            this.template_details[index].location_details = this.temp_location
            this.$forceUpdate();
        },
        getLocation(index) {
            // this.addressIndex = index;
            if (navigator.geolocation) {
                // timeout at 60000 milliseconds (60 seconds)
                var options = {
                    enableHighAccuracy: false,
                    timeout: 30000, // milliseconds (30 seconds)
                    maximumAge: 600000
                }; // milliseconds (10 minutes)
                navigator.geolocation.getCurrentPosition(
                    this.showLocation,
                    this.errorHandler,
                    this.assignLocationDetails(index),
                    options
                );
            } else {
                alert("Sorry, browser does not support geolocation!");
            }
        },
        getMultiPartLocation(part_index, field_index){
            if (navigator.geolocation) {
                this.location_loader = true
                console.log("Geolocation is supported!");
                // timeout at 60000 milliseconds (60 seconds)
                var options = {
                    enableHighAccuracy: false,
                    timeout: 30000, // milliseconds (30 seconds)
                    maximumAge: 600000
                }; // milliseconds (10 minutes)
                navigator.geolocation.getCurrentPosition(
                    this.showLocation,
                    this.errorHandler,
                    this.assignMultiLocationDetails(part_index, field_index),
                    options
                );
            } else {
                alert("Sorry, browser does not support geolocation!");
            }
            document.getElementById('DisableOnClick' + field_index + part_index).style.pointerEvents = 'none';
        },
        assignMultiLocationDetails(part_index, field_index){
            this.template_details[part_index].parts_data[field_index].location_details = this.temp_location
        },
        assignLocationDetails(index){
            this.template_details[index].location_details = this.temp_location
        },
        showLocation(position) {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
            let calllatlong = axios.create();
            delete calllatlong.defaults.headers.common['Authorization'];
            calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue + "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
            .then(response => {
                let address = response.data.results[0].formatted_address.split(", ");
                this.temp_location['street1'] =
                address[address.length - 6] || "";
                this.temp_location['township'] =
                address[address.length - 4] || "";
                this.temp_location['city'] = address[address.length - 3] || "";
                let statezip = address[address.length - 2]
                ? address[address.length - 2].split(" ")
                : ["", ""];
                this.temp_location['zip_code'] = statezip[0].match(/^[0-9]+$/)
                ? statezip[0]
                : statezip[1].match(/^[0-9]+$/)
                ? statezip[1]
                : "";
                this.temp_location['state'] = statezip[0].match(/^[a-zA-Z]+$/)
                ? statezip[0]
                : statezip[1].match(/^[a-zA-Z]+$/)
                ? statezip[1]
                : "";
                if (address[address.length - 1].includes("-")) {
                let countrySelected = address[address.length - 1].split(" - ");
                countrySelected.forEach(x => {
                        if (this.countries.includes(x)) {
                        this.temp_location['country'] = x;
                        } else {
                        this.temp_location['country'] = "";
                        }
                });
                } else {
                this.temp_location['country'] = address[address.length - 1];
                }
                this.temp_location['location_vmodel'] = response.data.results[0].formatted_address;
                this.temp_location['full_address'] = response.data.results[0].formatted_address;
                this.$forceUpdate();
            })
            .catch(e => {
                // this.errors.push(e)
            });
        },
        errorHandler(err) {
            if (err.code == 1) {
                alert("Please Allow Location Access");
            } else if (err.code == 2) {
                alert("Error: Position is unavailable!");
            }
        },
        tagsChangeData(update_tag, index){
            this.template_details[index].answer=update_tag
            this.$forceUpdate()
        },
        checkTicketType(){
            if(this.ticketType == null) {
                this.template_details = []
            }
        },
        async selectedTemplate(data){
            this.load_template = true
            this.save_loader = false
            this.approvers_data = []
            this.is_approvers_mandatory = false
            this.approvers_options = []
            try{
                let params = {
                    dynamic_template_id: data._id
                }
                let response = await this.getDynamicTemplate(params)
                this.template_details = response.response.fields
                this.ticket_details.template_type = response.response.template_type

                if(this.ticket_details.template_type == 'multi_part'){
                    this.approvers_options = response.response.approve_data
                    if(this.approvers_options.length > 0){
                        this.is_approvers_mandatory = true
                    } else {
                        this.is_approvers_mandatory = false
                    }
                    this.template_details = response.response.multi_parts_data
                    this.assignment_details.to = 'unassigned'
                    this.assignment_details.assigned_to = {
                        name : '-'
                    }
                } else {
                    this.is_approvers_mandatory = false
                    this.template_details = response.response.fields
                }
                this.getTemplateSpace()
                this.load_template = false
            } catch (error) {
                this.load_template = false
            }
        },
        // dragOverAttachment(evt) {
        //     // Prevent default behavior (Prevent file from being opened)
        //     evt.preventDefault();
        // },
        // dropAttachment(evt, index) {
        //     // Prevent default behavior (Prevent file from being opened)
        //     evt.preventDefault();
        //     // Use DataTransfer interface to access the file(s)
        //     [...evt.dataTransfer.files].forEach((file, i) => {
        //         this.uploadFromDrop(file, index)
        //     });
        // },
        // uploadFromDrop(event, index) {
        //     let contains_duplicates = false
        //     this.template_details[index].attach_files.forEach((e) => {
        //         if(e.name == event.name){
        //             contains_duplicates = true
        //         }
        //     })
        //     if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
        //         if(event) {
        //             var input = event;
        //         }
        //         if (input && event) {
        //             const CancelToken = axios.CancelToken;
        //             const source = CancelToken.source();
        //             let attachment = {
        //                 //id: uuidv4(),
        //                 name: input.name,
        //                 size: JSON.stringify(input.size),
        //                 source: source,
        //                 progress: 0,
        //                 created_time: new Date(),
        //                 error: ""
        //             }
        //             if(this.template_details[index].attach_files.length < 10){
        //                 this.template_details[index].attach_files.push(attachment)
        //                 this.getResumableURLByPart(input, this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
        //             } else {
        //                 this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
        //             }
        //         }
        //     } else if(contains_duplicates){
        //         this.$toasted.global.error("This file is already uploaded")
        //     } else {
        //         this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
        //     }
        // },
        // uploadAttachmentByPart(event, index){
        //     if(event) {
        //         var input = event.target;
        //     }
        //     if(event == undefined) {
        //         var input 
        //         input = this.$refs.upload.files
        //         let contains_duplicates = false
        //         this.template_details[index].attach_files.forEach((e) => {
        //             if(e.name == input[0].file.name){
        //                 contains_duplicates = true
        //             }
        //         })
        //         if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
        //             input['files'] = []
        //             input.files.push({
        //                 lastModified : input[0].file.lastModified,
        //                 name : input[0].file.name,
        //                 size : input[0].file.size,
        //                 type : input[0].file.type,
        //                 webkitRelativePath : input[0].file.webkitRelativePath,
        //                 lastModifiedDate : input[0].file.lastModifiedDate
        //             })
        //             const CancelToken = axios.CancelToken;
        //             const source = CancelToken.source();
        //             let attachment = {
        //                 name: input.files[0].name,
        //                 size: JSON.stringify(input.files[0].size),
        //                 source: source,
        //                 progress: 0,
        //                 created_time: new Date(),
        //                 error: "",
        //                 url:""
        //             }
        //             this.template_details[index].attach_files.push(attachment)
        //             this.getResumableURLByPart(input[0].file, this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
        //         } else if(contains_duplicates){
        //             this.$toasted.global.error("This file is already uploaded")
        //         }else {
        //             this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
        //         }
        //     }
        //     if (input.files && input.files[0] && event) {
        //         let contains_duplicates = false
        //         this.template_details[index].attach_files.forEach((e) => {
        //             if(e.name == input.files[0].name){
        //                 contains_duplicates = true
        //             }
        //         })
        //         if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
        //             const CancelToken = axios.CancelToken;
        //             const source = CancelToken.source();
        //             let attachment = {
        //                 name: input.files[0].name,
        //                 size: JSON.stringify(input.files[0].size),
        //                 source: source,
        //                 progress: 0,
        //                 created_time: new Date(),
        //                 error: ""
        //             }
        //             this.template_details[index].attach_files.push(attachment)
        //             this.$forceUpdate();
        //             this.getResumableURLByPart(input.files[0], this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
        //         } else if(contains_duplicates){
        //             this.$toasted.global.error("This file is already uploaded")
        //         } else {
        //             this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
        //         }
        //     }
        // },
        async searchTemplateDebouncer(search_key){
            this.ticket_type_loading = true
            this.template_search_key = search_key || '';
            try{
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: this.template_search_key,
                    sort_key: 'name',
                    sort_value: 1,
                    // template_type: 'default'
                }
                let response = await this.getDynamicTemplateList(params)
                this.ticket_type_options = response.response.dynamic_details
                this.ticket_type_count = response.response.dynamic_details.length
                this.ticket_type_loading = false
            } catch (error) {
            }
        },
        getTemplateSpace(){
            if(this.ticket_details.template_type == 'multi_part'){
                this.template_details.forEach((x,index) => {
                    // x.show = true
                    // x.attach_files = []
                    // x.is_send_for_review = this.is_approvers_mandatory
                    // x.part_name = x.name
                    // x.parts_data = JSON.parse(JSON.stringify(x.fields))
                    if(this.is_approvers_mandatory){
                        if(index == 0){
                            x.show = true
                            x.attach_files = []
                            x.is_send_for_review = this.is_approvers_mandatory
                            x.part_name = x.name
                            x.parts_data = JSON.parse(JSON.stringify(x.fields))
                            x.parts_data.forEach((data, data_index) => {
                                if(data.type == 'check_box' || data.type == 'radio_button') {
                                    data.answer = []
                                    data.error = false
                                    if(data.statement){
                                        data.reason = ''
                                    }
                                }
                                else if(data.type == 'tag'){
                                    data.entered_tag = ''
                                    data.answer = []
                                    data.error = false
                                }
                                else if(data.type == 'dropdown' && data.is_api_call_required == true){
                                    data.answer = ''
                                    data.error = false
                                    if(data.statement){
                                        data.reason = ''
                                    }
                                }
                                else if(data.type == 'drop_down' && data.is_api_call_required == false){
                                    data.answer = ''
                                    data.error = false
                                    if(data.statement){
                                        data.reason = ''
                                    }
                                }
                                else if(data.type == 'date_time'){
                                    data.date = ''
                                    data.time = ''
                                    data.error = false
                                }
                                else if(data.type == 'location'){
                                    data.answer = ''
                                    data.location_details = {
                                        address:"",
                                        city:"",
                                        country:"",
                                        full_address:"",
                                        location_vmodel:"",
                                        state:"",
                                        street1:"",
                                        township:"",
                                        zip_code:""
                                    }
                                    data.error = false
                                }
                                else {
                                    data.answer = ''
                                    data.error = false
                                }
                            })
                        } else {
                            // x.show = true
                            // x.attach_files = []
                            // x.is_send_for_review = this.is_approvers_mandatory
                            x.part_name = x.name
                            x.parts_data = []
                            // x.parts_data.forEach((data, data_index) => {
                            //     data.required = false
                            // })
                        }
                    } else {
                        x.show = true
                        x.attach_files = []
                        x.is_send_for_review = this.is_approvers_mandatory
                        x.part_name = x.name
                        x.parts_data = JSON.parse(JSON.stringify(x.fields))
                        x.parts_data.forEach((data, data_index) => {
                            if(data.type == 'check_box' || data.type == 'radio_button') {
                                data.answer = []
                                data.error = false
                                if(data.statement){
                                    data.reason = ''
                                }
                            }
                            else if(data.type == 'tag'){
                                data.entered_tag = ''
                                data.answer = []
                                data.error = false
                            }
                            else if(data.type == 'dropdown' && data.is_api_call_required == true){
                                data.answer = ''
                                data.error = false
                                if(data.statement){
                                    data.reason = ''
                                }
                            }
                            else if(data.type == 'drop_down' && data.is_api_call_required == false){
                                data.answer = ''
                                data.error = false
                                if(data.statement){
                                    data.reason = ''
                                }
                            }
                            else if(data.type == 'date_time'){
                                data.date = ''
                                data.time = ''
                                data.error = false
                            }
                            else if(data.type == 'location'){
                                data.answer = ''
                                data.location_details = {
                                    address:"",
                                    city:"",
                                    country:"",
                                    full_address:"",
                                    location_vmodel:"",
                                    state:"",
                                    street1:"",
                                    township:"",
                                    zip_code:""
                                }
                                data.error = false
                            }
                            else {
                                data.answer = ''
                                data.error = false
                            }
                        })
                    }
                    delete x.fields
                    delete x.name
                })
            } else {
                this.template_details.forEach((data,index) => {
                    if(data.type == 'check_box' || data.type == 'radio_button') {
                        this.template_details[index].answer = []
                        this.template_details[index].error = false
                        if(data.statement){
                            data.reason = ''
                        }
                    }
                    else if(data.type == 'tag'){
                        this.template_details[index].entered_tag = ''
                        this.template_details[index].answer = []
                        this.template_details[index].error = false
                    }
                    else if(data.type == 'dropdown' && data.is_api_call_required == true){
                        this.template_details[index].answer = ''
                        this.template_details[index].error = false
                        if(data.statement){
                            data.reason = ''
                        }
                    }
                    else if(data.type == 'drop_down' && data.is_api_call_required == false){
                        data.answer = ''
                        data.error = false
                        if(data.statement){
                            data.reason = ''
                        }
                    }
                    else if(data.type == 'date_time'){
                        this.template_details[index].date = ''
                        this.template_details[index].time = ''
                        this.template_details[index].error = false
                    }
                    else if(data.type == 'location'){
                        this.template_details[index].answer = ''
                        this.template_details[index].location_details = {
                            address:"",
                            city:"",
                            country:"",
                            full_address:"",
                            location_vmodel:"",
                            state:"",
                            street1:"",
                            township:"",
                            zip_code:""
                        }
                        this.template_details[index].error = false
                    }
                    else {
                        this.template_details[index].answer = ''
                        this.template_details[index].error = false
                    }
                })
            }
        },
        async getTicketTemplate(){
            this.ticket_type_loading = true
            try {
                let params = {
                    limit: 10,
                    search_key: '',
                    skip: 0,
                    sort_key: 'name',
                    sort_value: 1,
                    // template_type: 'default'
                }
                let response = await this.getDynamicTemplateList(params)
                this.ticket_type_options = response.response.dynamic_details
                this.ticket_type_count = this.ticket_type_options.length
                this.ticket_type_loading = false
                this.ticketTemplateListScrollable = false
            } catch (error) {
            }
        },
        async reachedEndOfTicketTemplate(reached){
            this.isVisibleTicket = reached;
            if (reached) {
                if(this.ticketTemplateListScrollable == false){
                    this.ticket_type_loading = true
                    let response = await this.getDynamicTemplateList({
                        search_key: this.template_search_key,
                        skip: this.ticket_type_count,
                        limit: 10,
                        sort_key: 'name',
                        sort_value: 1,
                        // template_type: 'default'
                    })
                    let temp_ticket_template_options = response.response.dynamic_details.length
                    if(response.response.skip == this.ticket_type_count){
                        if(temp_ticket_template_options > 0){
                            let tempfiles = response.response.dynamic_details
                            tempfiles.forEach(el => {
                                this.ticket_type_options.push(el)
                            })
                            this.ticket_type_count += response.response.dynamic_details.length
                            this.ticket_type_loading = false
                        } else {
                            this.ticketTemplateListScrollable = true
                            this.ticket_type_loading = false
                        }
                    }
                    this.ticket_type_loading = false
                }
            }
        },
        async getApiDD(){
            this.apicall_loading = true
            try{
                let params = {
                    limit: 10,
                    search_key: "",
                    skip: 0
                }
                let response = await this.getScmProductsDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        async searchTemplateApiDDDebouncer(search_key){
            this.apicall_loading = true
            // this.template_search_key = search_key || '';
            try{
                let params = {
                    limit: 10,
                    search_key: search_key,
                    skip: 0
                }
                let response = await this.getProductTemplatesDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        async getTemplateApiDD(){
            this.apicall_loading = true
            try{
                let params = {
                    limit: 10,
                    search_key: "",
                    skip: 0
                }
                let response = await this.getProductTemplatesDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        async searchApiDDDebouncer(search_key){
            this.apicall_loading = true
            // this.template_search_key = search_key || '';
            try{
                let params = {
                    limit: 10,
                    search_key: search_key,
                    skip: 0
                }
                let response = await this.getScmProductsDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        assignedToChange() {

        },
        moment(date) {
            return moment(date);
        },
        async openDepartmentList() {
            this.departments_loading = true;
            try {
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: ''
                };
                let response = await this.getDepartmentListApi(params);
                this.department_options = response.response.all_departments;
                this.department_count = response.response.all_departments.length;
                this.departments_loading = false;
            }
            catch (error) {
                // console.log(error);
            }
        },
        deleteAttachment(data, index){
            this.attachments.splice(index, 1);
        },
        deleteAttachmentByPart(attachment,part_index){
            this.template_details[part_index].attach_files.forEach((el,elindex)=>{
                if(el.url == attachment.url){
                    this.template_details[part_index].attach_files.splice(elindex,1)
                }
            })
            this.$forceUpdate()
        },
        async searchDepartmentList(search_key) {
            this.department_options = [];
            this.departments_loading = true;
            this.department_search_key = search_key;
            try {
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: this.department_search_key
                };
                let response = await this.getDepartmentListApi(params);
                this.department_options = response.response.all_departments;
                this.department_count = response.response.all_departments.length;
                this.departments_loading = false;
            }
            catch (error) {
                // console.log(error);
            }
        },
        async reachedEndOfDepartmentList(reached) {
            this.isVisible = reached;
            if (reached) {
                if (this.scrollable == false) {
                    this.departments_loading = true;
                    let params = {
                        skip: this.department_count,
                        limit: 10,
                        search_key: this.department_search_key
                    };
                    let response = await this.getDepartmentListApi(params);
                    let temp_department_options = response.response.all_departments.length;;
                    if (response.response.skip == this.department_count) {
                        if (temp_department_options.length > 0) {
                            let tempFiles = response.response.all_departments;
                            tempFiles.forEach(el => {
                                this.department_options.push(el);
                            });
                            this.department_count += response.response.all_departments.length;
                            this.departments_loading = false
                        } else {
                            this.scrollable = true
                            this.departments_loading = false
                        }
                    }
                    this.departments_loading = false
                }
            }
        },
        async getAllAssignToDebouncer(search_key){
            try {
                this.assign_options = []
                this.assign_loading = true
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getUserForTickets(params)
                this.assign_options = res.response.assigned_user_details
                this.assign_count = this.assign_options.length
                this.assign_loading = false
                this.assign_scrollable = false
            } catch (reason) {

            }
        },
        async reachedEndOfAssigned(reached){
            this.assign_visible = reached
            if (reached) {
                if (this.assign_scrollable == false) {
                    this.assign_loading = true
                    let params ={
                        skip:this.assign_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserForTickets(params)
                    let temp_assign_options = response.response.assigned_user_details.length;
                    if (response.response.skip == this.assign_count) {
                        if (temp_assign_options > 0) {
                            let tempFiles = response.response.assigned_user_details;
                            tempFiles.forEach(el => {
                                this.assign_options.push(el);
                            });
                            this.assign_count += response.response.assigned_user_details.length;
                            this.assign_loading = false
                        } else {
                            this.assign_scrollable = true
                            this.assign_loading = false
                        }
                    }
                    this.assign_loading = false
                }
            }
        },
        inputFile(newFile, oldFile) {
            this.temp_attachments = []
            if (newFile && oldFile) {
                if (newFile.active && !oldFile.active) {
                if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                    this.$refs.upload.update(newFile, { error: 'size' })
                }
                }
                if (newFile.progress !== oldFile.progress) {
                }
                if (newFile.error && !oldFile.error) {
                }
                if (newFile.success && !oldFile.success) {
                }
            }
            if (!newFile && oldFile) {
                if (oldFile.success && oldFile.response.id) {
                }
            }
            if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                if (this.uploadAuto && !this.$refs.upload.active) {
                this.$refs.upload.active = true
                }
            }
            this.input_file = newFile.file
            this.uploadAttachment(event)
        },
        goToListView() {
            this.$router.push('/facilitymanagement/listview');
        },
        dateFormat(inputDate, format) {
            let temp_date = inputDate.slice(3,5)
            let temp_month = inputDate.slice(0,2) - 1
            let temp_year = inputDate.slice(6,)
            //parse the input date
            const date = new Date(temp_year, temp_month, temp_date);
            //extract the parts of the date
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();

            //replace the month
            format = format.replace("MM", month.toString().padStart(2,"0"));

            //replace the year
            if (format.indexOf("yyyy") > -1) {
                format = format.replace("yyyy", year.toString());
            } else if (format.indexOf("yy") > -1) {
                format = format.replace("yy", year.toString().substr(2,2));
            }

            //replace the day
            format = format.replace("dd", day.toString().padStart(2,"0"));

            return format;
        },
        createSuccess() {
            if(this.ticket_details.template_type == 'default'){
                if(this.template_details.some(x => x.type == 'location')){
                    this.template_details.forEach((template, template_index) => {
                        if(template.type == 'location'  && template.required == true && template.location_details.location_vmodel == ''){
                            template.error = true
                        } else if(template.type == 'location' && template.location_details.location_vmodel != '') {
                            template.error = false
                        }
                    })
                }
                this.$validator.validateAll().then(async result => {
                    if(this.assignment_details.assigned_to.id == '' || this.assignment_details.assigned_to.id == null || this.assignment_details.assigned_to.id == undefined){
                        delete this.create_data.assignment_details
                    }
                    if (result && this.date_and_time.date && this.date_and_time.time) {
                        this.create_data.date_time.date = this.dateFormat(this.create_data.date_time.date,'dd-MM-yyyy').replace(/\//g, '-');
                        this.create_data.date_time.time = this.convertTime12to24WithoutSec(this.create_data.date_time.time);
                        this.create_data.attach_files.forEach((el, index) => {
                            delete el.id
                            delete el.error
                            delete el.progress
                            delete el.created_time
                            delete el.uploading
                            delete el.size
                        })
                        if(this.assign_a_ticket){
                            this.createAssignToData.template_data.forEach((template, index) => {
                                if(template.type == 'date_time'){
                                    template.answer = template.date + ' ' + template.time
                                    delete template.date
                                    delete template.time
                                }
                                if(template.type == 'tag'){
                                    template.answer.forEach((ti, ti_index) => {
                                        delete ti['tiClasses']
                                        template.answer[ti_index] = ti.text
                                    })
                                }
                                if(template.type == 'drop_down' && template.is_api_call_required == true){
                                    template.product = template.answer['_id']
                                    delete template.answer['category']
                                    delete template.answer['description']
                                    delete template.answer['item_code']
                                    delete template.answer['sub_category']
                                    delete template.answer['variant_id']
                                    delete template.answer['_id']
                                    delete template.answer['name']
                                    template.answer = template.product
                                    delete template.product
                                }
                                if(template.type == 'location'){
                                    template.answer = template.location_details.location_vmodel
                                    delete template.location_details
                                    delete template.error
                                }
                                if(template.type == 'check_box' || template.type == 'radio_button' || template.type == 'drop_down'){
                                    delete template['possible_values']
                                    if(template.hasOwnProperty('statement')){
                                        delete template.statement
                                    }
                                }
                                delete template['is_api_call_required']
                                delete template['required']
                                delete template['type']
                            })
                        }
                        this.addSecurityConcern();
                    } else {
                        this.warning_msg = "Please fill all the required fields";
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                        this.is_api_calling = false;
                        if(this.date_and_time.date == '' || this.date_and_time.date == null || this.date_and_time.date == undefined) {
                            this.is_date = true;
                        }
                        if(this.date_and_time.time == '' || this.date_and_time.time == null || this.date_and_time.time == undefined) {
                            this.is_time = true;
                        }
                    }
                });
            } else {
                let check_errors = []
                this.template_details.forEach((template, template_index) => {
                    template.parts_data.forEach((x, i) => {
                        if(x.type == 'location' && x.required == true && x.location_details.location_vmodel == '' && template_index == 0){
                            check_errors.push(true)
                            x.error = true
                        } else {
                            check_errors.push(false)
                            x.error = false
                        }
                    })
                })
                this.$validator.validateAll().then(result => {
                    if (result == true && this.attachments.length <= 10 && check_errors.every(x => x == false)){
                        this.attachments.forEach(attachment => {
                            delete attachment['created_time']
                            delete attachment['error']
                            delete attachment['id'];
                            delete attachment['progress']
                            delete attachment['size']
                            delete attachment['uploading']
                        })
                        localStorage.setItem("ticketDetails", JSON.stringify(this.create_multi_json));
                        let created_data = JSON.parse(localStorage.getItem('ticketDetails'));
                        created_data.template_data.forEach((template, index) => {
                            delete template.show
                            delete template.statement
                            template.attach_files.forEach((y) => {
                                delete y['created_time']
                                delete y['error']
                                delete y['id'];
                                delete y['progress']
                                delete y['size']
                                delete y['uploading']
                            })
                            template.parts_data.forEach((y, y_index) => {
                                if(y.type == 'date_time'){
                                    y.answer = y.date + ' ' + y.time
                                    delete y.date
                                    delete y.time
                                }
                                if(y.type == 'tag'){
                                    y.answer.forEach((ti, ti_index) => {
                                        delete ti['tiClasses']
                                        y.answer[ti_index] = ti.text
                                    })
                                    delete y.entered_tag
                                }
                                if(y.type == 'drop_down' && y.is_api_call_required == true){
                                    y.product = y.answer['_id']
                                    delete y.answer['category']
                                    delete y.answer['description']
                                    delete y.answer['item_code']
                                    delete y.answer['sub_category']
                                    delete y.answer['variant_id']
                                    delete y.answer['_id']
                                    delete y.answer['name']
                                    y.answer = y.product
                                    delete y.product
                                }
                                if(y.type == 'location'){
                                    y.answer = y.location_details.location_vmodel
                                    delete y.location_details
                                    delete y.error
                                }
                                if(y.type == 'check_box' || y.type == 'radio_button' || y.type == 'drop_down'){
                                    delete y['possible_values']
                                    if(template.hasOwnProperty('statement')){
                                        delete template.statement
                                    }
                                }
                                delete y['is_api_call_required']
                                delete y['required']
                                delete y['type']
                                delete y['error']
                            })
                        })
                        try{
                            this.addMultiSecurityConcern(created_data)
                        } catch(error) {
                            console.log(error)
                        }
                    }
                    else if(this.attachments.length > 10){
                        this.$toasted.global.error("10 Attachments are Allowed")
                    }else{
                        this.$toasted.global.error("Please Fill All The Required Fields")
                    }
                })
            }
        },
        checkError(i) {
            return i.error == false;
        },
        async addSecurityConcern() {
            this.is_api_calling = true;
            this.save_loader = true
            try {
                if(this.assign_a_ticket){
                    var response = await this.createSecurityConcern(this.createAssignToData);
                }else {
                    var response = await this.createSecurityConcern(this.create_data);
                }
                this.success_msg = response.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$router.push('/facilitymanagement/listview');
                }, 3000);
                this.save_loader = false
            }
            catch(error) {
                this.save_loader = false
                this.warning_msg = error;
                this.$refs.warning_modal.open();
                this.is_api_calling = false;
            }
        },
        async addMultiSecurityConcern(data){
            try{
                this.save_loader = true
                var response = await this.createSecurityConcern(data);
                if(response.status_id == 1){
                    this.success_msg = response.response.success_message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.save_loader = false
                        this.$router.push('/facilitymanagement/listview');
                    }, 3000);
                } else if(response.status_id == 0){
                    this.warning_msg = response.response.reason
                    this.save_loader = false
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } catch(err) {
                this.save_loader = false
                this.warning_msg = err
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        async getRequiredData(id) {
            this.ajax_call_inprogress = true;
            try {
                let params = {
                    facility_id: id
                };
                let response = await this.getFacilityLocationById(params);
                this.tag_location = response.response.facility_details.location;
                this.facility_name = response.response.facility_details.facility_name;
                this.product_id = response.response.facility_details.product_id;
                if(response.response.facility_details.status == false) {
                    this.facility_id_not_active = true;
                } else {
                    this.facility_id_not_active = false;
                }
                this.ajax_call_inprogress = false;
            }
            catch(error) {
                // console.log(error);
                this.url_not_found = true;
            }
        },
        async getDataById(id) {
            this.ajax_call_inprogress = true;
            try {
                let params = {
                    security_id: id
                };
                let response = await this.getSecurityConcernById(params);
                this.assign_a_ticket = response.response.assign_ticket
                this.assigned_by = response.response.assigned_by.id
                this.assigned_by_name = response.response.assigned_by.name
                if(response.response.hasOwnProperty('ticket_template')){
                    this.ticketType = {
                        name: response.response.ticket_template.name
                    } 
                    this.ticket_details = {
                        ticket_number : response.response.ticket_number,
                        ticket_id: response.response.ticket_id,
                        template_type: response.response.ticket_template.template_type,
                        ticket_status: response.response.ticket_status
                    }
                }
                if(response.response.assignment_details) {
                    if(!response.response.assignment_details.is_assigned){
                        this.assignment_details.assigned_to = {
                            name : '-'
                        }
                        this.assignment_details.to = 'unassigned'
                    } else {
                        this.assignment_details.to = response.response.assignment_details.to
                        this.assignment_details_id = response.response.assignment_details.id
                        this.assignment_details.assigned_to = {
                            id: response.response.assignment_details.id,
                            name: response.response.assignment_details.name
                        };
                    }
                }
                this.attachments = response.response.attach_files || [];
                this.date_and_time.date = response.response.date_time.date
                this.date_and_time.time = this.convertTime24To12(response.response.date_time.time);
                this.facility_name = response.response.facility_name;
                this.tag_location = response.response.location;
                this.comments = response.response.comments;
                this.ajax_call_inprogress = false;
            }
            catch(error) {
                // console.log(error);
            }
        },
        cameraSelected(event) {
            // console.log(event)
        },
        // async getCameraSelection() {
        //     const devices = await navigator.mediaDevices.enumerateDevices();
        //     const videoDevices = devices.filter(device => device.kind === 'videoinput');
        //     this.camera_selection = videoDevices;
        //     this.selected_camera_device = videoDevices[0].deviceId;
        // },
        // openCaptureImage() {
        //     if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
        //         this.show_capture_image = true;
        //         setTimeout(() => {
        //             this.$modal.show('capture-image');
        //             this.getCameraSelection()
        //             this.toggleCamera();
        //         }, 500);
        //     }
        //     else {
        //         this.warning_msg = "Camera capture device not found";
        //         this.$refs.warning_modal.open();
        //         setTimeout(() => {
        //             this.$refs.warning_modal.close();
        //         }, 3000);
        //     }
        // },
        // getResumableURLByPart(file, attachment) {
        //     this.isUploadingInProgress = true;
        //     let usage_type = {
        //         usage: "attachment"
        //     } 
        //     let data = {
        //         file: attachment.name
        //     }
        //     data = new FormData()
        //     data.append('file',file)
        //     Object.keys(usage_type).map(e => {
        //         data.append(e, JSON.stringify(usage_type[e]))
        //     })
        //     this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
        //         onUploadProgress: function (progressEvent) {
        //             let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
        //             if (progress < 100) {
        //                 attachment.progress = progress;
        //             }
        //         }.bind(this)
        //     })
        //     .then(response => {
        //         let resumable_url = response.data.url;
        //         attachment.url = resumable_url;
        //         attachment.progress = 100;
        //         attachment.uploading = false;
        //         this.isUploadingInProgress = false;
        //         delete attachment['source'];
        //         if (response.data.hasOwnProperty('reason')){
        //             attachment.error = "Error Uploading"
        //             if (attachment.url == undefined) {
        //                 this.check_attachments = true
        //             } else {
        //                 this.check_attachments = false
        //             }
        //         }
        //         this.$forceUpdate();
        //     })
        //     .catch(error => {
        //     })
        // },
        // openCaptureImageMulti(field_index) {
        //     if(this.template_details[field_index].attach_files.length < 10){
        //         if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
        //             this.show_capture_image_multi = true;
        //             setTimeout(() => {
        //                 this.$modal.show(`capture-image${field_index}`);
        //                 this.getCameraSelection()
        //                 this.toggleCameraMultiPart(field_index);
        //             }, 500);
        //         }
        //         else {
        //             this.warning_msg = "Camera capture device not found";
        //             this.$refs.warning_modal.open();
        //             setTimeout(() => {
        //                 this.$refs.warning_modal.close();
        //             }, 3000);
        //         }
        //     } else {
        //         this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
        //     }
        // },
        hideView() {
            this.toggleCamera();
        },
        // toggleCamera() {
        //     if(this.isCameraOpen) {
        //         this.isCameraOpen = false;
        //         this.isPhotoTaken = false;
        //         this.isShotPhoto = false;
        //         this.stopCameraStream();
        //     } else {
        //         this.isCameraOpen = true;
        //         this.createCameraElement();
        //     }
        // },

        // createCameraElement() {
        //     this.isLoading = true;
        //     const constraints = (window.constraints = {
        //         audio: false,
        //         video: true
        //     });

        //     navigator.mediaDevices
        //         .getUserMedia(constraints)
        //         .then(stream => {
        //         this.isLoading = false;
        //         this.$refs.camera_capture.srcObject = stream;
        //     })
        //     .catch(error => {
        //         this.isLoading = false;
        //         this.show_capture_image = false;
        //         setTimeout(() => {
        //             this.$modal.hide('capture-image');
        //         }, 500);
        //         alert("Please allow the camera access or your browser may not support it.");
        //     });
        // },

        // stopCameraStream() {
        //     let tracks = this.$refs.camera_capture.srcObject.getTracks();
        //     tracks.forEach(track => {
        //         track.stop();
        //     });
        //     this.show_capture_image = false;
        //     setTimeout(() => {
        //         this.$modal.hide('capture-image');
        //         this.stopCameraStream();
        //     }, 500);
        // },

        // takePhoto() {
        //     if(!this.isPhotoTaken) {
        //         this.isShotPhoto = true;
        //         const FLASH_TIMEOUT = 50;
        //         setTimeout(() => {
        //         this.isShotPhoto = false;
        //         }, FLASH_TIMEOUT);
        //     }
        //     this.isPhotoTaken = !this.isPhotoTaken;
        //     const context = this.$refs.canvas.getContext('2d');
        //     context.drawImage(this.$refs.camera_capture, 0, 0, 250, 250);
        // },
        // blobToFile(theBlob, fileName){
        //     //A Blob() is almost a File() - it's just missing the two properties below which we will add
        //     theBlob.lastModifiedDate = new Date();
        //     theBlob.name = fileName;
        //     const myFile = new File([theBlob], 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png', {
        //         type: theBlob.type,
        //     });
        //     return myFile;
        // },
        // uploadAttachmentFromCamera(file_data){
        //     if (file_data) {
        //         const CancelToken = axios.CancelToken;
        //         const source = CancelToken.source();
        //         let attachment = {
        //             name: file_data.name,
        //             size: JSON.stringify(file_data.size),
        //             source: source,
        //             progress: 0,
        //             created_time: new Date(),
        //             error: ""
        //         }
        //         this.attachments.push(attachment)
        //         this.getResumableURL(file_data, this.attachments[this.attachments.length - 1]);
        //     }
        // },
        // stopCameraStreamMultiPart(field_index) {
        //     let tracks = this.$refs.camera_capture[field_index].srcObject.getTracks();
        //     tracks.forEach(track => {
        //         track.stop();
        //     });
        //     this.show_capture_image_multi = false;
        //     setTimeout(() => {
        //         this.$modal.hide(`capture-image${field_index}`);
        //         this.stopCameraStreamMultiPart(field_index);
        //     }, 500);
        // },
        // hideViewMultiPart(index){
        //     this.toggleCameraMultiPart(index)
        // },
        // toggleCameraMultiPart(field_index) {
        //     if(this.isCameraOpen) {
        //         this.stopCameraStreamMultiPart(field_index);
        //         this.isCameraOpen = false;
        //         this.isPhotoTaken = false;
        //         this.isShotPhoto = false;
        //     } else {
        //         this.isCameraOpen = true;
        //         this.createCameraElementMultiPart(field_index);
        //     }
        // },
        // createCameraElementMultiPart(field_index) {
        //     this.isLoading = true;
        //     const constraints = (window.constraints = {
        //         audio: false,
        //         video: true
        //     });
        //     navigator.mediaDevices
        //         .getUserMedia(constraints)
        //         .then(stream => {
        //         this.isLoading = false;
        //         this.$refs.camera_capture[field_index].srcObject = stream;
        //     })
        //     .catch(error => {
        //         this.isLoading = false;
        //         this.show_capture_image_multi = false;
        //         setTimeout(() => {
        //             this.$modal.hide(`capture-image${field_index}`);
        //         }, 500);
        //         alert("Please allow the camera access or your browser may not support it.");
        //     });
        // },
        // takePhotoMultiPart(field_index) {
        //     if(!this.isPhotoTaken) {
        //         this.isShotPhoto = true;
        //         const FLASH_TIMEOUT = 50;
        //         setTimeout(() => {
        //         this.isShotPhoto = false;
        //         }, FLASH_TIMEOUT);
        //     }
        //     this.isPhotoTaken = !this.isPhotoTaken;
        //     const context = this.$refs.canvas[field_index].getContext('2d');
        //     context.drawImage(this.$refs.camera_capture[field_index], 0, 0, 250, 250);
        // },
        // async downloadImageByPart(index){
        //     const canvas = document.getElementById('photoTaken').toDataURL("image/png")
        //     const base64 = await fetch(canvas);
        //     const blob = await base64.blob();
        //     let fill = this.blobToFile(blob, 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
        //     this.uploadAttachmentFromCameraByPart(fill, index);
        //     this.show_capture_image_multi = false;
        //     this.$modal.hide(`capture-image${index}`);
        //     this.toggleCameraMultiPart(index)
        //     this.stopCameraStreamMultiPart(index);
        // },
        // uploadAttachmentFromCameraByPart(file_data, index){
        //     let contains_duplicates = false
        //     this.template_details[index].attach_files.forEach((e) => {
        //         if(e.name == file_data.name){
        //             contains_duplicates = true
        //         }
        //     })
        //     if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
        //         if (file_data) {
        //             const CancelToken = axios.CancelToken;
        //             const source = CancelToken.source();
        //             let attachment = {
        //                 name: file_data.name,
        //                 size: JSON.stringify(file_data.size),
        //                 source: source,
        //                 progress: 0,
        //                 created_time: new Date(),
        //                 error: ""
        //             }
        //             this.template_details[index].attach_files.push(attachment)
        //             this.getResumableURLByPart(file_data, this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
        //         }
        //     } else if(contains_duplicates){
        //         this.$toasted.global.error("This file is already uploaded")
        //     } else {
        //         this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
        //     }
        // },
        // async downloadImage() {
        //     const canvas = document.getElementById("photoTaken").toDataURL("image/png")
        //     const base64 = await fetch(canvas);
        //     const blob = await base64.blob();
        //     let fill = this.blobToFile(blob, 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
        //     this.uploadAttachmentFromCamera(fill);
        //     this.show_capture_image = false;
        //     setTimeout(() => {
        //         this.$modal.hide('capture-image');
        //         this.toggleCamera()
        //         this.stopCameraStream();
        //     }, 500);
        // }
    },
    mounted(){
        this.assigned_by_name = this.loggedInUser.full_name
        this.assigned_by = this.loggedInUser.user_id
        if(this.$route.path.startsWith('/facilitymanagement/securityconcern/view')) {
            this.is_view_screen = true;
            this.getDataById(this.$route.params.id);
        } else if(this.$route.query.facility_id != '' && this.$route.query.facility_id != null && this.$route.query.facility_id != undefined) {
            this.getRequiredData(this.$route.query.facility_id);
            this.is_view_screen = false;
            this.url_not_found = false;
        } else {
            this.url_not_found = true;
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        create_data() {
            return {
                "assign_ticket": this.assign_a_ticket,
                "assigned_by": {
                    "id": this.assigned_by,
                    "name": this.assigned_by_name
                },
                "attach_files": this.attachments,
                "date_time": this.date_and_time,
                "facility_name": this.facility_name,
                "location": this.tag_location,
                "comments": this.comments,
            }
        },
        createAssignToData(){
            return {
                "approvers_list": [],
                "assign_ticket": this.assign_a_ticket,
                "assigned_by": {
                    "id": this.assigned_by,
                    "name": this.assigned_by_name
                },
                "assignment_details": {
                    "id": this.assignment_details.assigned_to.id,
                    "name": this.assignment_details.assigned_to.name,
                    "is_assigned": true,
                    "to": this.assignment_details.to
                },
                "attach_files": this.attachments,
                "date_time": this.date_and_time,
                "facility_name": this.facility_name,
                "location": this.tag_location,
                "comments": this.comments,
                "template_data": this.template_details,
                "ticket_template": {
                    "name": this.ticketType.name,
                    "id": this.ticketType._id
                },
            }
        },
        create_multi_json(){
            let temp_template_details = []
            this.template_details.forEach((x, x_index) => {
                if(x_index == 0 || (!this.is_approvers_mandatory && x_index > 0)){
                    temp_template_details.push(x)
                }
            })
            let temp_date_time = {
                date: this.dateFormat(this.date_and_time.date,'dd-MM-yyyy').replace(/\//g, '-'),
                time: this.convertTime12to24WithoutSec(this.date_and_time.time)
            }
            return{
                assignment_details: {
                    is_assigned: false
                },
                assign_ticket: this.assign_a_ticket,
                assigned_by: {
                    id: this.loggedInUser.user_id,
                    name: this.loggedInUser.full_name
                },
                assignment_details: {
                    is_assigned: false
                },
                is_send_for_review: this.is_approvers_mandatory,
                approvers_list: this.approvers_data.map(x => x.id),
                attach_files: this.attachments,
                comments: this.comments,
                date_time: temp_date_time,
                facility_name: this.facility_name,
                location: this.tag_location,
                product_id: '',
                template_data: temp_template_details,
                ticket_template: {
                    name: this.ticketType.name,
                    id: this.ticketType._id,
                    template_type: this.ticket_details.template_type
                }
            }
        },
        watchApprovers(){
            let temp_approvers_options = this.approvers_options.map(x => x.id)
            let temp_approvers_data = this.approvers_data.map(x => x.id)
            return temp_approvers_options.length == temp_approvers_data.length
        }
    },
    created() {
        this.getAllAssignTo = debounce(this.getAllAssignToDebouncer, 500)
        this.searchTemplate = debounce(this.searchTemplateDebouncer, 500)
        this.searchTemplateApiDD = debounce(this.searchTemplateApiDDDebouncer, 500)
        this.searchApiDD = debounce(this.searchApiDDDebouncer, 500)
        const dict = {
            custom: {
                department:{
                    required:() => "Department is required"
                },
                priority:{
                    required:() => "Priority is required"
                },
                assign_to:{
                    required:() => "Assigned to is required"
                },
                reason_of_concern:{
                    required:() => "Reason of Concern is required"
                },
                ticketType:{
                    required:() => "Ticket Template is Required"
                },
                notes:{
                    required:() => "Notes is required"
                },
            }
        }
        this.$validator.localize('en', dict)
    },
    destroyed(){

    }
}
</script>
<style scoped>
    .inner-content-border {
        padding: 16px 0 12px;
        border-radius: 5px;
        box-shadow: 0 0 4px 0 #808495;
        background-color: #fff;
    }
    .header-outer {
        width: 100%;
        background: #005dae;
        color: #fff;
        font-size: 14px;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-bottom: 10px;
        padding-right: 20px;
        border-radius: 1px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .attachment {
        border-radius: 4px;
        border: solid 0.5px #2071d4;
        background-color: #fff;
    }
    .form-group, .form-check {
        will-change: unset !important;
    }
    .success-check {
        border: 1px solid #676767 !important;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        padding: 6px 6px 6px 1px;
        border-left: 0 none !important;
    }
    .attachment-bg-new{
        border: 1px solid #005dae !important;
        background: transparent !important;
        width: 80%;
    }
    .file-bg{
        background-color: #bbd9fd;
        padding: 10px;
        border-radius: 2px;
    }
    #progressbar {
        margin-bottom: 10px;
        overflow: hidden;
        color: #303031;
        width: 100%;
        display: flex;
        margin: 0;
        padding: 0;
        align-items: center;
        justify-content: center;
    }

    #progressbar .active {
        color: #303031
    }

    #progressbar li {
        list-style-type: none;
        font-size: 12px;
        width: 33%;
        position: relative;
        text-align: center;
    }
    #progressbar li strong {
        display: block;
        opacity: 0.5;
    }

    #progressbar li strong.active {
        opacity: 1;
    }

    #progressbar li img {
        position: relative;
        z-index: 2;
    }
    #progressbar li:before {
        content: '';
        width: 100%;
        border-top: dashed 2px #cdcdcd;
        position: absolute;
        left: -50%;
        top: 27px;
        z-index: 1
    }
    #progressbar li:first-child::before{
        width: 0% !important;
    }
    #progressbar li.active:before {
        border-top: solid 2px #005dae;
    }
    .img-upload {
        padding-left: 6rem !important;
        padding-right: 6rem !important;
    }
    .camera-loading {
        overflow: hidden;
        height: 100%;
        position: absolute;
        width: 100%;
        min-height: 150px;
        margin: 3rem 0 0 -1.2rem;
    }
    .camera-loading ul {
        height: 100%;
        position: absolute;
        width: 100%;
        z-index: 999999;
        margin: 0;
    }
    .camera-box {
        border: 2.5px solid #00b8f5;
        padding: 5px 5px 0 5px;
    }
    .desc-textarea {
        padding-top: 6px!important;
        width: 100%;
        background: transparent;
        color: #303031;
        border-radius: 5px;
        border: 0.6px solid #676767!important;
        resize: none;
        padding: 10px;
        overflow-y: auto;
        padding-right: 75px!important;
        min-height: 140px;
    }
    .gps-logo{
        border-radius: 5px;
        padding: 3px;
        border: 1px solid rgb(0, 0, 0);
        position: relative;
        top: 7px;
        margin-left: 5px;
    }
    .color-blue{
        color: #005dae;
    }
    .w-130px{
        width: 130px !important
    }
    .text-align-left{
        text-align: left !important;
    }
    .boxHeader{
        background: #005dae;
        color: #fff;
        padding: 5px 25px;
        font-weight: 500;
        font-size: 14px;
    }
    .position-absolute{
        position: absolute;
    }
    .text-reason{
        font-size: 14px !important;
        padding: 5px 5px 40px 10px !important;
        display: block;
        width: 100%;
        border-radius: 5px;
        border: solid 1px #3f3f3f!important;
        background: transparent !important;
        color: #000;
        font-weight: 500;
        border-radius: 5px !important;
        margin-top: 20px;
        /* margin-left:20px; */
    }
    .infoHeader>.descriptionheader .description-text-header-right img{
        width: 23px !important;
    }
    .filter-multiple .custom__tag1 {
        background: #81aee6;
        color: #fff;
        padding: 4px 8px !important;
        border-radius: 20px;
        margin-right: 5px !important;
        display: inline-block;
        margin-bottom: 5px !important;
    }
    .filter-multiple .custom__tag1 .custom__remove i {
        position: relative;
        top: 0px;
        right: -3px;
    }
    .filterSelectedName1{
        position: relative;
        top:0px;
    }
    .filter-multiple .custom__tag1 .custom__remove i {
        position: relative;
        top: 0px;
        right: -3px;
    }
    .dynamic-section{
        /* background-color: rgba(0, 0, 0, 0.05) !important; */
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
        border-radius: 6px !important;
    }
    .dynamic-section .table-content .table-content-data thead tr th{
        background-color: #0d84f2;
    }
    .dynamic-section .table-content .table-content-data tbody tr td{
        background-color: #cce3fc;
    }
    .bg-grey{
        background-color: rgba(0,0,0,0.06) !important;
    }
</style>